module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "title": "Potatoes"
    }
  }, [_c('div', {
    staticClass: "titlepage"
  }, [_c('div', [_c('div', [_c('h1', {
    staticClass: "title"
  }, [_c('a', {
    attrs: {
      "id": "d0e192",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Potatoes ")])]), _c('a', {
    attrs: {
      "id": "d0e192",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  })]), _c('a', {
    attrs: {
      "id": "d0e192",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  })]), _c('a', {
    attrs: {
      "id": "d0e192",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  })]), _c('a', {
    attrs: {
      "id": "d0e192",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_c('p', [_c('span', {
    staticClass: "dropcap"
  }, [_vm._v("Of ")]), _vm._v("all things mashed, potatoes are likely the most\n                universally known and adored. The kid in all of us can barely resist the thought of\n                sitting down to a steaming bowl of creamy potato deliciousness, preferably with a\n                melting pool of butter at the top, trickling like molten, golden love down a fluffy\n                mashed potato mountain. ")]), _vm._v(" "), _c('p', [_vm._v("Because potatoes have such a neutral flavor (earthy, buttery, slightly nutty), they\n                open up the door to a huge pantry of spice, herb, and ingredient pairings, from blue\n                cheese to nuts, literally. Of course, all potatoes are not created equal, and some\n                are better suited to particular preparations than others. There are hundreds of\n                varieties grown around the world, and in the United States, there are more than 100\n                kinds available. Under this large potato umbrella (which includes red, white,\n                yellow, purple/blue, fingerling, and petite potatoes), there are essentially three\n                potato types: ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "subhead"
  }, [_vm._v("Waxy")]), _vm._v(" These thin-skinned potatoes have a lower starch\n                content and a higher moisture content. They hold their shape very well when cooked\n                and are best used for roasting, boiling, casseroles, and potato salads. Popular\n                varieties include red bliss and new potatoes. ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "subhead"
  }, [_vm._v("Idaho/russet")]), _vm._v(" This celebrated baking potato has a much\n                higher starch content and lower moisture content. Unlike its waxy cousins, it tends\n                to fall apart when cooked (unless when baked with its skin on). It’s an excellent\n                choice for baking, frying, and mashing. ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "subhead"
  }, [_vm._v("All-purpose")]), _vm._v(" The lead player in this medium starch\n                content potato pool is the ubiquitous and delicious Yukon Gold. It’s my favorite\n                pick for mashed potatoes, but is also fabulous baked, fried, or in casseroles,\n                salads, or gratins. ")]), _vm._v(" "), _c('p', [_vm._v("Many of these beautiful spuds are put to work in this chapter, as well as the popular\n                sweet potato, which is so juicy hot right out of the oven that it begs for almost\n                nothing except a dab of butter and a dusting of salt and pepper. ")]), _vm._v(" "), _c('p', [_vm._v("Before we get started, there are a few things to keep in mind about potatoes. All\n                store best in cool, dark places (like a pantry or a cellar). Refrigerating raw\n                potatoes will convert their starch to sugar and muddle both taste and texture. Many\n                potatoes will discolor or oxidize once peeled and cut, so try to avoid doing so\n                until just before cooking. ")]), _vm._v(" "), _c('div', {
    staticClass: "mediaobject",
    attrs: {
      "title": "Photo of potatoes."
    }
  }, [_c('img', {
    attrs: {
      "alt": "Photo of potatoes.",
      "src": "images/Chapter_Opener_Potatoes-2-966.jpg"
    }
  })])]), _c('h2', [_c('a', {
    attrs: {
      "id": "d0e192",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }), _c('a', {
    attrs: {
      "id": "masterrv",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Ultimate Mashed Potatoes Master\n                Recipe—Rustic Version ")])]), _c('a', {
    attrs: {
      "id": "masterrv",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_c('p', {
    staticClass: "yield"
  }, [_vm._v("Yields 6 servings ")]), _vm._v(" "), _c('p', [_vm._v("Making the ultimate bowl of mashed potatoes is not hard, but taking a few carefully\n                calculated and timed steps will make all the difference between ho-hum and\n                magnificent. It all begins with the potato. Yukon Gold is the best at absorbing just\n                the right amount of liquid and seasoning while allowing pure potato flavor to shine\n                through; russets will work, but I feel like their starchiness pulls in too much\n                cream. Boiled potatoes should always start in cold, salted water. Once cooked, the\n                potatoes need to be well-drained and returned to the pot to dry out over medium heat\n                before receiving the cream/liquid. The cream and butter that are incorporated into\n                the hot potatoes also need to be hot. They can be heated in a measuring cup in the\n                microwave (high for 1–2 minutes) or simmered on the stove. ")]), _vm._v(" "), _c('p', [_vm._v("Keeping potatoes warm is as simple as setting a bowl of mashed potatoes over a water\n                bath simmering gently over the stove—and don’t be afraid to add additional hot cream\n                as liquid potentially evaporates. Serve hot and well-seasoned. ")]), _vm._v(" "), _c('div', {
    staticClass: "simplelist"
  }, [_c('p', {
    staticClass: "nospace"
  }, [_vm._v("6 medium to large Yukon Gold potatoes, peeled and cut into\n                    1-1/2-inch (3.8-cm) cubes (about 6 cups / 1.08 kg) ")]), _vm._v(" "), _c('p', {
    staticClass: "nospace"
  }, [_vm._v("Water ")]), _vm._v(" "), _c('p', {
    staticClass: "nospace"
  }, [_vm._v("2 tablespoons kosher or sea salt ")]), _vm._v(" "), _c('p', {
    staticClass: "nospace"
  }, [_vm._v("1 cup (240 ml) half-and-half ")]), _vm._v(" "), _c('p', {
    staticClass: "nospace"
  }, [_vm._v("3 tablespoons unsalted butter ")]), _vm._v(" "), _c('p', {
    staticClass: "nospace"
  }, [_vm._v("1/2 cup sour cream, room temperature ")]), _vm._v(" "), _c('p', {
    staticClass: "nospace"
  }, [_vm._v("1-1/2 teaspoons kosher or sea salt ")]), _vm._v(" "), _c('p', {
    staticClass: "nospace"
  }, [_vm._v("1 teaspoon ground black pepper ")])]), _vm._v(" "), _c('p', [_vm._v("Place the potatoes into a medium pot and add enough cold water to cover generously.\n                Add 2 tablespoons salt. Bring to a boil over high heat, reduce to a simmer, and\n                cook, uncovered, until the potatoes are very tender and break apart with light\n                pressure from a fork. Drain very well in a colander. Return potatoes to the same pot\n                and dry out for 1–2 minutes, stirring, over medium heat. ")])]), _c('p', [_c('a', {
    attrs: {
      "id": "masterrv",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Meanwhile, heat together the half-and-half and butter in a small skillet over medium\n                heat until simmering (or in the microwave for 1–2 minutes on high heat). Using a\n                standard manual masher (")]), _c('a', {
    staticClass: "link",
    attrs: {
      "href": "#/ch02#bmasht",
      "id": "d0e251"
    }
  }, [_vm._v("Basic\n                    Mashing Tools")]), _vm._v("), begin breaking up the potatoes. Simultaneously, add the hot\n                cream and butter in thirds. Once the cream is fully incorporated, mash in the sour\n                cream, salt, and pepper. Taste and adjust seasonings as needed. Serve immediately or\n                keep warm over a warm water bath (up to 1 hour), adding more cream as needed. ")]), _vm._v(" "), _c('div', {
    staticClass: "mediaobject",
    attrs: {
      "title": "Photo of Ultimate Mashed Potatoes Master Recipe—Rustic Version."
    }
  }, [_c('img', {
    attrs: {
      "alt": "Photo of Ultimate Mashed Potatoes Master Recipe—Rustic Version.",
      "src": "images/Ultimate_Mashed_Potato_Master_Recipe_-_Rustic--Edit-956.jpg"
    }
  })]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "id": "masterel",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Ultimate Mashed Potatoes Master\n                Recipe—Elegant Version ")])]), _c('a', {
    attrs: {
      "id": "masterel",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_c('p', {
    staticClass: "yield"
  }, [_vm._v("Yields 6 servings ")])]), _c('p', [_c('a', {
    attrs: {
      "id": "masterel",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("This is exactly the same recipe as the ")]), _c('a', {
    staticClass: "link",
    attrs: {
      "href": "#/ch04#masterrv",
      "id": "d0e265",
      "title": "Ultimate Mashed Potatoes Master Recipe—Rustic Version"
    }
  }, [_vm._v("Rustic\n                    Version")]), _vm._v(", the only difference is you have the opportunity to save a step and\n                leave the scrubbed skins on the Yukon Golds and pass them through a food mill ("), _c('a', {
    staticClass: "link",
    attrs: {
      "href": "#/ch02#bmasht",
      "id": "d0e268"
    }
  }, [_vm._v("Basic Mashing Tools")]), _vm._v(", before\n                folding in the warm cream and butter. The resulting mashed potatoes are slightly\n                more airy, and also smoother—decidedly more elegant. And the process of pressing the\n                skins out of the potatoes, which are retained inside the food mill, provides another\n                level of potato flavor and nutrition. ")]), _vm._v(" "), _c('h4', [_c('a', {
    attrs: {
      "id": "d0e271",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Suggested Variations ")])]), _c('a', {
    attrs: {
      "id": "d0e271",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }), _c('p', [_c('a', {
    attrs: {
      "id": "d0e271",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_c('span', {
    staticClass: "subhead"
  }, [_vm._v("Fresh Herbs ")]), _vm._v("Depending on what you’re serving them with,\n                mashed potatoes are a wonderful backdrop to many fresh herbs. Remember to add the\n                fragile fine herbs (basil, tarragon, or chives) just before serving or they will\n                wilt and discolor. Adding 3 tablespoons of finely chopped fresh rosemary to the\n                master recipe goes beautifully with pork or chicken, or the same quantity of chives\n                marries fantastically with sautéed sole or another delicate fish. Basil, cut into a\n                fine ")]), _c('a', {
    staticClass: "link",
    attrs: {
      "href": "#/ch03#chiff",
      "id": "d0e277"
    }
  }, [_vm._v("chiffonade")]), _vm._v(", is smashing\n                with an Italian- or Thai-inspired side, while parsley adds a fresh smattering of\n                earthy, green complementary flavor to almost anything. ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "subhead"
  }, [_vm._v("Garlic ")]), _vm._v("Sauté 6 cloves of thinly sliced garlic in 1\n                tablespoon of olive oil over medium-low heat until lightly caramelized and softened,\n                5–7 minutes. Smash the garlic with your chef’s knife and fold into the master\n                recipe—divinity! The flavors will develop further with a little heat, so keep it in\n                the bowl over the water bath for a few minutes before serving. ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "subhead"
  }, [_vm._v("Horseradish")]), _vm._v(" Whip 1 tablespoon of prepared horseradish\n                into the master recipe, and you have a winning formula for a two-in-one-punch side\n                and sauce for prime rib or anywhere horseradish is at home, including poached or\n                grilled salmon. ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "subhead"
  }, [_vm._v("Truffle Oil/Fresh Truffles ")]), _vm._v("The French and Italians have\n                long recognized the beauty of mashed potatoes with this fragrant earthly delight.\n                It’s tough to find the real deal, but if you can find a beautiful fresh truffle\n                (white or black), chop it up very finely and add a tablespoon or two to the master\n                recipe. Alternatively, drizzle a generous teaspoon or so of best-quality truffle oil\n                over warm mashed potatoes for an extra sexy, elegant finish. ")]), _vm._v(" "), _c('div', {
    staticClass: "mediaobject",
    attrs: {
      "title": "Photo of Ultimate Mashed Potatoes Master Recipe—Elegant Version."
    }
  }, [_c('img', {
    attrs: {
      "alt": "Photo of Ultimate Mashed Potatoes Master Recipe—Elegant Version.",
      "src": "images/Ultimate_Mashed_Potatoes_Master_Recipe_-_Elegant_-4-953.jpg"
    }
  })]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "id": "riced",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Basic Riced Potatoes ")])]), _c('a', {
    attrs: {
      "id": "riced",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_c('p', {
    staticClass: "yield"
  }, [_vm._v("Yields about 4 cups (840 g) ")])]), _c('p', [_c('a', {
    attrs: {
      "id": "riced",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Riced potatoes are actually baked potato flesh removed from the skins (save these)\n                that are passed through a food mill. The resulting unadulterated potatoes are as\n                light as air. Their fluffy texture is well-suited to many dishes. When you’re making\n                them, prepare several at once to save time and minimize waste. Any leftovers will\n                freeze well, and you can get a nice batch of delicious potato skins (")]), _c('a', {
    staticClass: "link",
    attrs: {
      "href": "#/ch04#cbcskins",
      "id": "d0e303",
      "title": "Cheddar-Bacon-Celery Skins"
    }
  }, [_vm._v("Cheddar-Bacon-Celery Skins")]), _vm._v(") out of the deal. The same exact process can be\n                used for sweet potatoes, which also have lovely texture when roasted ("), _c('a', {
    staticClass: "link",
    attrs: {
      "href": "#/ch04#spotpud",
      "id": "d0e306",
      "title": "Sweet Potato Indian Pudding"
    }
  }, [_vm._v("Sweet Potato Indian Pudding")]), _vm._v(") though more\n                moist and heavier. ")]), _vm._v(" "), _c('div', {
    staticClass: "simplelist"
  }, [_c('p', {
    staticClass: "nospace"
  }, [_vm._v("8 medium russet potatoes, well-scrubbed and each pierced twice\n                ")])]), _vm._v(" "), _c('p', [_vm._v("Preheat oven to 425° F (220° C). Place the potatoes on the center rack and bake until\n                the skins are bubbly and crisp, and they’re tender all the way to the center when\n                pierced with a knife. Remove from oven to cool. ")]), _vm._v(" "), _c('p', [_vm._v("When cool enough to handle, cut in half vertically and scoop out the cooked flesh\n                with a soup spoon, being careful not to break or damage the skins. Reserve the skins\n                separately. Process the cooked potato by passing through a food mill ("), _c('a', {
    staticClass: "link",
    attrs: {
      "href": "#/ch02#bmasht",
      "id": "d0e316"
    }
  }, [_vm._v("Basic Mashing Tools")]), _vm._v(") into a\n                large bowl. Cover and refrigerate, or freeze up to few months. Use as directed in\n                accompanying recipes. ")]), _vm._v(" "), _c('div', {
    staticClass: "mediaobject",
    attrs: {
      "title": "Photo of Basic Riced Potatoes."
    }
  }, [_c('img', {
    attrs: {
      "alt": "Photo of Basic Riced Potatoes.",
      "src": "images/Basic_Riced_Potatoes-9000-Edit-Edit-933.jpg"
    }
  })]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "id": "d0e324",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Double-Onion Mashed Whammy ")])]), _c('a', {
    attrs: {
      "id": "d0e324",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_c('p', {
    staticClass: "yield"
  }, [_vm._v("Yields 6 to 8 servings ")]), _vm._v(" "), _c('p', [_vm._v("The delicate, subtle onion flavor of leeks goes beautifully with the sweetness and\n                surprise color of red onions in this rustic green- and purple-flecked mash. Pair it\n                with something equally rustic, such as meatloaf with pan gravy, or pot roast. ")]), _vm._v(" "), _c('div', {
    staticClass: "simplelist"
  }, [_c('p', {
    staticClass: "nospace"
  }, [_vm._v("3 large Yukon Gold potatoes, peeled and cut into 1-1/2-inch\n                    (3.8-cm) cubes (about 2-1/2 cups / 450 g) ")]), _vm._v(" "), _c('p', {
    staticClass: "nospace"
  }, [_vm._v("1/2 large red onion, peeled and cut into 1-inch (2.5-cm) cubes,\n                    about 1 cup (150 g) ")]), _vm._v(" "), _c('p', {
    staticClass: "nospace"
  }, [_vm._v("2 leeks, base trimmed and dark-green leaves removed, cut into\n                    1-inch (2.5-cm) dice and rinsed well in fresh cold water to remove grit ")]), _vm._v(" "), _c('p', {
    staticClass: "nospace"
  }, [_vm._v("Water ")]), _vm._v(" "), _c('p', {
    staticClass: "nospace"
  }, [_vm._v("2 tablespoons kosher or sea salt ")]), _vm._v(" "), _c('p', {
    staticClass: "nospace"
  }, [_vm._v("1 cup (240 ml) half-and-half ")]), _vm._v(" "), _c('p', {
    staticClass: "nospace"
  }, [_vm._v("3 tablespoons unsalted butter ")]), _vm._v(" "), _c('p', {
    staticClass: "nospace"
  }, [_vm._v("1-3/4 teaspoons kosher or sea salt ")]), _vm._v(" "), _c('p', {
    staticClass: "nospace"
  }, [_vm._v("1 teaspoon ground black pepper ")]), _vm._v(" "), _c('p', {
    staticClass: "nospace"
  }, [_vm._v("3 tablespoons finely chopped fresh parsley")])]), _vm._v(" "), _c('p', [_vm._v("Place the potatoes, red onion, and leeks in a medium pot. Add enough cold water to\n                generously cover, along with 2 tablespoons salt. Bring to a boil over high heat and\n                reduce to simmer. Cook, uncovered, until all of the ingredients are very tender,\n                20–25 minutes. Drain very well in a colander. Return to same pot and heat over\n                medium heat for 1–2 minutes, stirring, to dry out the ingredients. ")])]), _c('p', [_c('a', {
    attrs: {
      "id": "d0e324",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Meanwhile, heat the half-and-half and butter together in a small pan over medium heat\n                (or in a microwave for 1–3 minutes on high heat), until heated through. Using a\n                traditional manual masher (")]), _c('a', {
    staticClass: "link",
    attrs: {
      "href": "#/ch02#bmasht",
      "id": "d0e355"
    }
  }, [_vm._v("Basic\n                    Mashing Tools")]), _vm._v("), begin breaking up the potato mixture. Add the hot cream and\n                butter in thirds, mashing all along the way, until consistency is smooth. Add salt,\n                pepper, and fresh parsley. Serve immediately or keep warm over simmering water bath. ")]), _vm._v(" "), _c('div', {
    staticClass: "mediaobject",
    attrs: {
      "title": "Photo of Double-Onion Mashed Whammy."
    }
  }, [_c('img', {
    attrs: {
      "alt": "Photo of Double-Onion Mashed Whammy.",
      "src": "images/Double_Onion_Mashed_Whammy-2-954.jpg"
    }
  })]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "id": "d0e363",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Golden Cauliflower Mash ")])]), _c('a', {
    attrs: {
      "id": "d0e363",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_c('p', {
    staticClass: "yield"
  }, [_vm._v("Yields 6 to 8 servings ")]), _vm._v(" "), _c('p', [_vm._v("Yukon Golds provide much-needed texture levity to puréed cauliflower, while\n                cauliflower provides snow-white color appeal and a smooth, buttery flavor that makes\n                this mash an instant favorite. Processing with a food mill aerates and integrates\n                the ingredients best of all, but a traditional manual masher will also work. A\n                flurry of fresh chives at the end adds a beautiful touch. This makes the perfect\n                side to complete a homey roasted chicken dinner. ")]), _vm._v(" "), _c('div', {
    staticClass: "simplelist"
  }, [_c('p', {
    staticClass: "nospace"
  }, [_vm._v("5 medium Yukon Gold potatoes, peeled and cut into 1-1/2-inch\n                    (3.8-cm) cubes, about 5 cups (900 g) ")]), _vm._v(" "), _c('p', {
    staticClass: "nospace"
  }, [_vm._v("1/2 head cauliflower, center stalk and base removed (about 2 cups\n                    / 460 g florets) ")]), _vm._v(" "), _c('p', {
    staticClass: "nospace"
  }, [_vm._v("Water ")]), _vm._v(" "), _c('p', {
    staticClass: "nospace"
  }, [_vm._v("2 tablespoons kosher or sea salt ")]), _vm._v(" "), _c('p', {
    staticClass: "nospace"
  }, [_vm._v("1 cup (240 ml) half-and-half ")]), _vm._v(" "), _c('p', {
    staticClass: "nospace"
  }, [_vm._v("3 tablespoons unsalted butter ")]), _vm._v(" "), _c('p', {
    staticClass: "nospace"
  }, [_vm._v("1/2 cup (120 ml) sour cream ")]), _vm._v(" "), _c('p', {
    staticClass: "nospace"
  }, [_vm._v("1-1/2 teaspoons kosher or sea salt ")]), _vm._v(" "), _c('p', {
    staticClass: "nospace"
  }, [_vm._v("1 teaspoon ground black pepper ")]), _vm._v(" "), _c('p', {
    staticClass: "nospace"
  }, [_vm._v("2 tablespoons finely chopped fresh chives")])]), _vm._v(" "), _c('p', [_vm._v("Place the potatoes and cauliflower in a medium pot. Add enough cold water to\n                generously cover, along with 2 tablespoons salt. Bring to a boil over high heat and\n                reduce to simmer. Cook, uncovered, until all of the ingredients are very tender,\n                20–25 minutes. Drain very well in a colander. Return to same pot and heat over\n                medium heat for 1–2 minutes, stirring, to dry out the ingredients. ")])]), _c('p', [_c('a', {
    attrs: {
      "id": "d0e363",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Meanwhile, heat the half-and-half and butter together in a small pan over medium heat\n                (or in a microwave for 1–2 minutes on high heat), until heated through. Pour the\n                cooked potatoes and cauliflower into the bowl of a food mill (")]), _c('a', {
    staticClass: "link",
    attrs: {
      "href": "#/ch02#bmasht",
      "id": "d0e394"
    }
  }, [_vm._v("Basic Mashing Tools")]), _vm._v("), in batches\n                (probably 3 depending on size of the food mill), positioned over a large bowl. Using\n                a wooden spoon, stir in the hot half-and-half and butter in thirds. To finish, stir\n                in the sour cream, salt, pepper, and fresh chives. Taste and adjust seasoning as\n                necessary. Serve immediately or keep warm over simmering water bath. ")]), _vm._v(" "), _c('div', {
    staticClass: "mediaobject",
    attrs: {
      "title": "Photo of cauliflower."
    }
  }, [_c('img', {
    attrs: {
      "alt": "Photo of cauliflower.",
      "src": "images/Golden_Cauliflower_Mash-9445-Edit-Edit-Edit-920.jpg"
    }
  })]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "id": "d0e402",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Colossal Greek Shepherd’s Pie ")])]), _c('a', {
    attrs: {
      "id": "d0e402",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_c('p', {
    staticClass: "yield"
  }, [_vm._v("Yields 8 to 10 servings ")])]), _c('p', [_c('a', {
    attrs: {
      "id": "d0e402",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Ground lamb, oregano, lemon, mint, artichokes, kalamata olives, and tangy feta cheese\n                cast a lovely Greek glow on the leftover mashed potato base in this easily assembled\n                dish that is perfect for entertaining guests and family alike. While this dish is\n                toothsome and hearty, the sunny flavors of the Mediterranean keep it fresh and\n                light. Use Ultimate Mashed Potatoes leftovers, either ")]), _c('a', {
    staticClass: "link",
    attrs: {
      "href": "#/ch04#masterrv",
      "id": "d0e408",
      "title": "Ultimate Mashed Potatoes Master Recipe—Rustic Version"
    }
  }, [_vm._v("Rustic")]), _vm._v(" or "), _c('a', {
    staticClass: "link",
    attrs: {
      "href": "#/ch04#masterel",
      "id": "d0e411",
      "title": "Ultimate Mashed Potatoes Master Recipe—Elegant Version"
    }
  }, [_vm._v("Elegant")]), _vm._v(", if\n                you have them. Otherwise, you’ll need to make a fresh batch. ")]), _vm._v(" "), _c('h4', [_c('a', {
    attrs: {
      "id": "d0e414",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Meat Layer ")])]), _c('a', {
    attrs: {
      "id": "d0e414",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }), _c('div', {
    staticClass: "simplelist"
  }, [_c('a', {
    attrs: {
      "id": "d0e414",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_c('p', {
    staticClass: "nospace"
  }, [_vm._v("1 tablespoon olive oil ")]), _vm._v(" "), _c('p', {
    staticClass: "nospace"
  }, [_vm._v("1 pound (450 g) ground lamb ")]), _vm._v(" "), _c('p', {
    staticClass: "nospace"
  }, [_vm._v("1/2 teaspoon kosher or sea salt ")]), _vm._v(" "), _c('p', {
    staticClass: "nospace"
  }, [_vm._v("1/2 teaspoon ground black pepper ")]), _vm._v(" "), _c('p', {
    staticClass: "nospace"
  }, [_vm._v("1 teaspoon dried oregano leaves ")])]), _c('p', {
    staticClass: "nospace"
  }, [_c('a', {
    attrs: {
      "id": "d0e414",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("2 tablespoons fresh mint leaves, cut thinly into 1/8-inch (3-mm)\n                    ribbons (")]), _c('a', {
    staticClass: "link",
    attrs: {
      "href": "#/ch03#chiff",
      "id": "d0e429"
    }
  }, [_vm._v("chiffonade")]), _vm._v(") ")]), _vm._v(" "), _c('p', {
    staticClass: "nospace"
  }, [_vm._v("1 tablespoon fresh lemon juice ")]), _vm._v(" "), _c('p', {
    staticClass: "nospace"
  }, [_vm._v("1/4 cup (40 g) currants, optional ")])]), _vm._v(" "), _c('h4', [_c('a', {
    attrs: {
      "id": "d0e436",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Potato and Vegetable Layers ")])]), _c('a', {
    attrs: {
      "id": "d0e436",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_c('div', {
    staticClass: "simplelist"
  }, [_c('p', {
    staticClass: "nospace"
  }, [_vm._v("3/4 cup (110 g) crumbled feta or goat cheese ")]), _vm._v(" "), _c('p', {
    staticClass: "nospace"
  }, [_vm._v("3/4 cup (135 g) coarsely chopped pitted kalamata olives ")]), _vm._v(" "), _c('p', {
    staticClass: "nospace"
  }, [_vm._v("3 cups (650 g) leftover mashed potatoes ")]), _vm._v(" "), _c('p', {
    staticClass: "nospace"
  }, [_vm._v("1 cup (170 g) canned marinated artichoke hearts, drained, rinsed,\n                    and coarsely chopped ")])])]), _c('h4', [_c('a', {
    attrs: {
      "id": "d0e436",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }), _c('a', {
    attrs: {
      "id": "d0e447",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Topping ")])]), _c('a', {
    attrs: {
      "id": "d0e447",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_c('div', {
    staticClass: "simplelist"
  }, [_c('p', {
    staticClass: "nospace"
  }, [_vm._v("1/3 cup (40 g) ricotta cheese")])]), _vm._v(" "), _c('p', [_vm._v("Preheat oven to 375° F (190° C). Begin with the meat layer. Heat the olive oil in a\n                large skillet over medium high. Crumble in the lamb, salt, and pepper. Cook,\n                stirring and breaking up with a wooden spoon, until browned, about 8 minutes. Drain\n                off any excess fat and discard. Stir in the oregano, mint, lemon juice, and\n                currants. Taste and adjust seasonings as needed. ")]), _vm._v(" "), _c('p', [_vm._v("To compile, using a paper towel, rub down the interior bottom and sides of a large\n                casserole pan with olive oil. Stir the feta and kalamata olives into the mashed\n                potatoes until combined. Using a spatula, evenly arrange the potato mixture in a\n                single layer in the bottom of the casserole pan. Top this with an even layer of\n                artichokes. Top this with the reserved meat mixture, spreading evenly. ")]), _vm._v(" "), _c('p', [_vm._v("To finish, place small dollops of ricotta cheese on top of the meat mixture, pressing\n                down to spread into the meat. Bake, uncovered, for 40 minutes, or until bubbling and\n                hot. Let set for 10 minutes before serving. Serve hot with a simple garden salad. ")]), _vm._v(" "), _c('div', {
    staticClass: "mediaobject",
    attrs: {
      "title": "Photo of Colossal Greek Shepherd’s Pie."
    }
  }, [_c('img', {
    attrs: {
      "alt": "Photo of Colossal Greek Shepherd’s Pie.",
      "src": "images/Colossal_Greek_Shepherd%27s_Pie-9003-Edit-Edit-Edit-932.jpg"
    }
  })])]), _c('h2', [_c('a', {
    attrs: {
      "id": "d0e447",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }), _c('a', {
    attrs: {
      "id": "d0e463",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Traditional English Shepherd’s\n                Pie ")])]), _c('a', {
    attrs: {
      "id": "d0e463",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_c('p', {
    staticClass: "yield"
  }, [_vm._v("Yields 8 to 10 servings ")])]), _c('p', [_c('a', {
    attrs: {
      "id": "d0e463",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("This recipe uses leftover potatoes from the Ultimate Mashed Potatoes ")]), _c('a', {
    staticClass: "link",
    attrs: {
      "href": "#/ch04#masterrv",
      "id": "d0e469",
      "title": "Ultimate Mashed Potatoes Master Recipe—Rustic Version"
    }
  }, [_vm._v("???")]), _vm._v(". If you\n                are missing leftovers, you’ll need to prepare a fresh batch. Other purée bases that\n                are well-suited to this dish include "), _c('a', {
    staticClass: "link",
    attrs: {
      "href": "#/ch04#tcelery",
      "id": "d0e471",
      "title": "Triple-Threat Celery Mash"
    }
  }, [_vm._v("Triple-Threat Celery Mash")]), _vm._v(", "), _c('span', {
    staticClass: "link",
    attrs: {
      "href": "#/ch07#parsnip",
      "id": "d0e474",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Purely Parsnip\n                    Purée")]), _vm._v(", and "), _c('span', {
    staticClass: "link",
    attrs: {
      "href": "#/ch07#ruta",
      "id": "d0e477",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Buttery Parsley Rutabaga Mash")]), _vm._v(". This\n                recipe is good enough to put any of them to fresh use. A thick layer of bubbly mild\n                cheddar tops it all off. ")]), _vm._v(" "), _c('h4', [_c('a', {
    attrs: {
      "id": "d0e480",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Meat Layer ")])]), _c('a', {
    attrs: {
      "id": "d0e480",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_c('div', {
    staticClass: "simplelist"
  }, [_c('p', {
    staticClass: "nospace"
  }, [_vm._v("1 tablespoon unsalted butter ")]), _vm._v(" "), _c('p', {
    staticClass: "nospace"
  }, [_vm._v("1/2 cup (120 g) finely chopped red onion or shallot ")]), _vm._v(" "), _c('p', {
    staticClass: "nospace"
  }, [_vm._v("1-1/4 pounds (570 g) 80 percent lean/20 percent fat ground beef ")]), _vm._v(" "), _c('p', {
    staticClass: "nospace"
  }, [_vm._v("1 teaspoon kosher or sea salt ")]), _vm._v(" "), _c('p', {
    staticClass: "nospace"
  }, [_vm._v("1/2 teaspoon ground black pepper ")]), _vm._v(" "), _c('p', {
    staticClass: "nospace"
  }, [_vm._v("1 teaspoon ground curry powder (red, yellow, or green) ")])])]), _c('h4', [_c('a', {
    attrs: {
      "id": "d0e480",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }), _c('a', {
    attrs: {
      "id": "d0e495",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Potato and Vegetable Layers ")])]), _c('a', {
    attrs: {
      "id": "d0e495",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_c('div', {
    staticClass: "simplelist"
  }, [_c('p', {
    staticClass: "nospace"
  }, [_vm._v("3 cups (650 g) leftover mashed potatoes ")]), _vm._v(" "), _c('p', {
    staticClass: "nospace"
  }, [_vm._v("2 tablespoons unsalted butter ")]), _vm._v(" "), _c('p', {
    staticClass: "nospace"
  }, [_vm._v("3 medium carrots, peeled and cut into 1/4-inch (6-mm) dice (about\n                    1-1/2 cups / 190 g) ")]), _vm._v(" "), _c('p', {
    staticClass: "nospace"
  }, [_vm._v("Pinch of kosher or sea salt and ground black pepper ")]), _vm._v(" "), _c('p', {
    staticClass: "nospace"
  }, [_vm._v("2 tablespoons water ")]), _vm._v(" "), _c('p', {
    staticClass: "nospace"
  }, [_vm._v("1-1/2 cups (200 g) frozen sweet peas ")]), _vm._v(" "), _c('p', {
    staticClass: "nospace"
  }, [_vm._v("1/4 cup (10 g) finely chopped fresh parsley ")]), _vm._v(" "), _c('p', {
    staticClass: "nospace"
  }, [_vm._v("2 tablespoons butter, room temperature ")]), _vm._v(" "), _c('p', {
    staticClass: "nospace"
  }, [_vm._v("3 cups (360 g) grated mild or medium cheddar cheese")])]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "subhead"
  }, [_vm._v("Meat Layer ")]), _vm._v("Preheat oven to 350° F (175° C). Melt butter\n                in a large sauté pan over medium heat. Add the onion and cook, stirring until\n                softened, about 5 minutes. Crumble in the beef and season with salt and pepper. Stir\n                to break up the beef, and brown over medium heat, 5–8 minutes. Drain off all visible\n                fat and discard. Reserve beef in the pan and stir in curry powder. ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "subhead"
  }, [_vm._v("Potato and Vegetable Layers ")]), _vm._v("Prepare and reserve the\n                mashed potatoes separately. Melt butter in a large skillet over medium heat. Add the\n                carrots, salt, and pepper. Toss to evenly coat in butter and seasoning. Add the\n                water, reduce the heat to medium low and cook, uncovered, until the water has cooked\n                off and the carrots have softened al dente, about 5 minutes. Stir in the peas and\n                parsley and remove from the heat. Set aside. ")]), _vm._v(" "), _c('p', [_vm._v("To compile, butter the bottom and sides of a large casserole pan with the\n                room-temperature butter. Add the prepared beef mixture, spreading evenly with a\n                spatula. Add the pea-and-carrot mixture, spreading evenly with a spatula. Finish\n                with the potatoes, spreading evenly. Top with an even layer of the cheese. Bake,\n                uncovered, until bubbly and heated through, 40–45 minutes. Let set for 10 minutes\n                before cutting. Serve hot. ")]), _vm._v(" "), _c('div', {
    staticClass: "mediaobject",
    attrs: {
      "title": "Photo of Traditional English Shepherd’s Pie."
    }
  }, [_c('img', {
    attrs: {
      "alt": "Photo of Traditional English Shepherd’s Pie.",
      "src": "images/Traditional_English_Shepard%27s_Pie-8913-Edit-Edit-Edit-935.jpg"
    }
  })])]), _c('h2', [_c('a', {
    attrs: {
      "id": "d0e495",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }), _c('a', {
    attrs: {
      "id": "d0e531",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Elegant Smashed Egg and Sweet\n                Gherkin Potato Salad ")])]), _c('a', {
    attrs: {
      "id": "d0e531",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_c('p', {
    staticClass: "yield"
  }, [_vm._v("Yields 8 to 10 servings ")]), _vm._v(" "), _c('p', [_vm._v("Finely puréed hard-boiled eggs, barely bound with sour cream and mayonnaise, get a\n                sweet, pungent bite from tiny bites of chopped sweet gherkin pickles in this\n                refined, waxy red potato salad. The simplicity of this salad is what makes it so\n                perfect. ")])]), _c('h4', [_c('a', {
    attrs: {
      "id": "d0e531",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }), _c('a', {
    attrs: {
      "id": "d0e537",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Eggs ")])]), _c('a', {
    attrs: {
      "id": "d0e537",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_c('div', {
    staticClass: "simplelist"
  }, [_c('p', {
    staticClass: "nospace"
  }, [_vm._v("4 large eggs, room temperature ")]), _vm._v(" "), _c('p', {
    staticClass: "nospace"
  }, [_vm._v("Water ")]), _vm._v(" "), _c('p', {
    staticClass: "nospace"
  }, [_vm._v("1 tablespoon vinegar ")])])]), _c('h4', [_c('a', {
    attrs: {
      "id": "d0e537",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }), _c('a', {
    attrs: {
      "id": "d0e546",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Salad ")])]), _c('a', {
    attrs: {
      "id": "d0e546",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_c('div', {
    staticClass: "simplelist"
  }, [_c('p', {
    staticClass: "nospace"
  }, [_vm._v("10 medium (about 2 pounds / 900 g) unpeeled waxy red potatoes,\n                    well-scrubbed and cut into 1-inch (2.5-cm) cubes ")]), _vm._v(" "), _c('p', {
    staticClass: "nospace"
  }, [_vm._v("Water ")]), _vm._v(" "), _c('p', {
    staticClass: "nospace"
  }, [_vm._v("1 tablespoon kosher or sea salt ")]), _vm._v(" "), _c('p', {
    staticClass: "nospace"
  }, [_vm._v("1 cup (230 g) full-fat sour cream ")]), _vm._v(" "), _c('p', {
    staticClass: "nospace"
  }, [_vm._v("1/2 cup (120 g) mayonnaise ")]), _vm._v(" "), _c('p', {
    staticClass: "nospace"
  }, [_vm._v("1 tablespoon Dijon mustard ")]), _vm._v(" "), _c('p', {
    staticClass: "nospace"
  }, [_vm._v("6 sweet gherkin pickles, very finely chopped (about 1/2 cup / 80\n                    g) ")]), _vm._v(" "), _c('p', {
    staticClass: "nospace"
  }, [_vm._v("3 tablespoons sweet gherkin pickle juice (from the jar) ")]), _vm._v(" "), _c('p', {
    staticClass: "nospace"
  }, [_vm._v("2 teaspoons kosher or sea salt ")]), _vm._v(" "), _c('p', {
    staticClass: "nospace"
  }, [_vm._v("1 teaspoon ground black pepper ")]), _vm._v(" "), _c('p', {
    staticClass: "nospace"
  }, [_vm._v("3 scallions, base and green tops trimmed to 3 inches (7.6 cm)\n                    above white base, very finely chopped on the bias")])]), _vm._v(" "), _c('p', [_vm._v("For the eggs, gently place the eggs in a medium pot. Cover generously with water (at\n                least 2 inches / 5 cm above the eggs) and add vinegar. Bring to a boil over high\n                heat. Once at a full boil, remove from heat and keep the eggs in the heated water\n                for exactly 15 minutes. Drain. Place the eggs in a bowl of heavily iced cold water\n                for exactly 5 minutes. Drain. ")])]), _c('p', [_c('a', {
    attrs: {
      "id": "d0e546",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Peel and remove the shell of each egg under running tap water. Cut the eggs in half\n                and process the whites and yolks in the bowl of a food processor or through a food\n                mill (")]), _c('a', {
    staticClass: "link",
    attrs: {
      "href": "#/ch02#bmasht",
      "id": "d0e575"
    }
  }, [_vm._v("Basic Mashing Tools")]), _vm._v(")\n                until flour fine then turn out into a large bowl. Set aside. ")]), _vm._v(" "), _c('p', [_vm._v("To finish the salad, place the potatoes in a medium pot, cover with cold water, add\n                salt, and bring to a boil over high heat. Reduce heat to medium low and cook,\n                uncovered, for 15–18 minutes until very tender, but still holding their shape. Drain\n                well and cool. ")]), _vm._v(" "), _c('p', [_vm._v("Return to the reserved eggs and whisk in the sour cream, mayonnaise, mustard,\n                gherkins, and pickle juice until smooth. Stir in the salt, pepper, and scallions.\n                Gently fold in the reserved potatoes and stir to combine. Cover with plastic wrap\n                and refrigerate for 1 hour (and up to overnight) to allow the flavors to develop. ")]), _vm._v(" "), _c('p', [_vm._v("Remove from the refrigerator at least 15 minutes before serving to bring the salad\n                closer to room temperature, where it will have its fullest flavor. It’s beautiful\n                and delicious beside a small mound of arugula or served in tender lettuce (such as\n                Bibb or Boston) cups. ")]), _vm._v(" "), _c('div', {
    staticClass: "mediaobject",
    attrs: {
      "title": "Photo of Elegant Smashed Egg and Sweet Gherkin Potato Salad."
    }
  }, [_c('img', {
    attrs: {
      "alt": "Photo of Elegant Smashed Egg and Sweet Gherkin Potato Salad.",
      "src": "images/Elegant_Smashed_Egg_%26_Gherkin_Potato_Salad--963.jpg"
    }
  })]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "id": "d0e589",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Blue Cheese and Black Pepper\n                Duchesse Potatoes ")])]), _c('a', {
    attrs: {
      "id": "d0e589",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_c('p', {
    staticClass: "yield"
  }, [_vm._v("Yields 8 servings ")]), _vm._v(" "), _c('p', [_vm._v("No blue cheese and peppercorn sauce required for your fillet, not with this gutsy\n                potato sharing the same plate. The sweetness of a gentle blue cheese hits just the\n                right note with the heat of black pepper. Both are tempered by a bit of cream and\n                butter, which flesh out these twice-baked beauties. Because the potatoes can be\n                fully prepped ahead of time and baked just before serving, they are excellent menu\n                picks for entertaining. ")]), _vm._v(" "), _c('div', {
    staticClass: "simplelist"
  }, [_c('p', {
    staticClass: "nospace"
  }, [_vm._v("4 medium russet potatoes (about 3/4 pound / 340 g each),\n                    well-scrubbed and pierced 3 times with a knife ")]), _vm._v(" "), _c('p', {
    staticClass: "nospace"
  }, [_vm._v("3/4 cup (180 ml) half-and-half ")]), _vm._v(" "), _c('p', {
    staticClass: "nospace"
  }, [_vm._v("2 tablespoons unsalted butter, room temperature ")]), _vm._v(" "), _c('p', {
    staticClass: "nospace"
  }, [_vm._v("2/3 cup (90 g) crumbled mild blue cheese ")]), _vm._v(" "), _c('p', {
    staticClass: "nospace"
  }, [_vm._v("1/2 teaspoon kosher or sea salt ")]), _vm._v(" "), _c('p', {
    staticClass: "nospace"
  }, [_vm._v("1 teaspoon ground black pepper ")]), _vm._v(" "), _c('p', {
    staticClass: "nospace"
  }, [_vm._v("1 tablespoon finely chopped fresh parsley ")])]), _vm._v(" "), _c('p', [_vm._v("Preheat oven to 425° F (220° C). Place potatoes on a baking sheet. Bake until the\n                jackets start to crisp and the centers are extremely tender when pierced with a\n                knife, about 1 hour (more for a larger potato). Remove from oven and reserve until\n                cool enough to handle. ")]), _vm._v(" "), _c('p', [_vm._v("Cut each potato in half vertically. Gently scoop out the filling of each half,\n                leaving approximately 1/4-inch (6-mm) border of cooked flesh on each potato, being\n                careful not to break through the skin. If necessary, cut a small flat space on the\n                bottom center of each half so it can sit upright when returned to baking sheet for\n                second cooking. ")])]), _c('p', [_c('a', {
    attrs: {
      "id": "d0e589",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Place the scooped potato flesh into a large bowl. Mash, using a manual masher, or for\n                a fluffier finish, blend with an electric mixer (")]), _c('a', {
    staticClass: "link",
    attrs: {
      "href": "#/ch02#bmasht",
      "id": "d0e616"
    }
  }, [_vm._v("Basic Mashing Tools")]), _vm._v("), with\n                half-and-half, butter, and blue cheese. Add the salt and pepper and taste to adjust\n                seasoning as needed. Gently spoon the filling back into the reserved potato halves,\n                forming a small mound on top of each. ")]), _vm._v(" "), _c('p', [_vm._v("Place the filled potatoes on a rimmed baking sheet and return to preheated 425° F\n                (220° C) oven. Cook for 25–30 minutes, until puffy, hot, and just golden on top.\n                Serve hot, with a light crumbling of blue cheese, freshly ground black pepper, and a\n                sprinkle of fresh parsley. Crunchy, smoky grilled steaks are a welcome addition to\n                this side party! ")]), _vm._v(" "), _c('div', {
    staticClass: "mediaobject",
    attrs: {
      "title": "Photo of Blue Cheese and Black Pepper Duchesse Potatoes."
    }
  }, [_c('img', {
    attrs: {
      "alt": "Photo of Blue Cheese and Black Pepper Duchesse Potatoes.",
      "src": "images/Blue_Cheese_%26_Black_Pepper_Duchesse_Potatoes--Edit-947.jpg"
    }
  })]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "id": "d0e626",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Ricotta, Lemon, and Basil Potato\n                Cakes ")])]), _c('a', {
    attrs: {
      "id": "d0e626",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_c('p', {
    staticClass: "yield"
  }, [_vm._v("Yields 8 large servings ")]), _vm._v(" "), _c('p', [_vm._v("Mashed potatoes have a way of disappearing quickly in my home. They probably do in\n                yours, too. On the rare occasion I do have some leftover mashed goodness hanging\n                around, one of the best ways to repurpose them is to mold them into crispy fried\n                potato cakes. The lightness of ricotta turns these cakes into veritable potato cloud\n                puffs, threaded with lemon zest and fresh basil, with a crunchy panko bread crumb\n                exterior. The Japanese crumbs, available in most groceries these days, give an extra\n                enticing crispy edge to the cakes—if you can’t find them, substitute unseasoned\n                traditional bread crumbs. ")])]), _c('div', {
    staticClass: "simplelist"
  }, [_c('a', {
    attrs: {
      "id": "d0e626",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }), _c('p', {
    staticClass: "nospace"
  }, [_c('a', {
    attrs: {
      "id": "d0e626",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("3 cups (650 g) leftover or freshly prepared mashed potatoes (")]), _c('a', {
    staticClass: "link",
    attrs: {
      "href": "#/ch04#masterrv",
      "id": "d0e635",
      "title": "Ultimate Mashed Potatoes Master Recipe—Rustic Version"
    }
  }, [_vm._v("Ultimate\n                        Mashed Potatoes Master Recipes")]), _vm._v(") ")]), _vm._v(" "), _c('p', {
    staticClass: "nospace"
  }, [_vm._v("1/2 cup (55 g) sifted all-purpose flour ")]), _vm._v(" "), _c('p', {
    staticClass: "nospace"
  }, [_vm._v("1 egg yolk, beaten ")]), _vm._v(" "), _c('p', {
    staticClass: "nospace"
  }, [_vm._v("1/4 to 1/2 cup (30 to 60 g) full-fat ricotta cheese (depends on\n                    wetness of the mashed potatoes) ")]), _vm._v(" "), _c('p', {
    staticClass: "nospace"
  }, [_vm._v("2 tablespoons fresh basil, cut into "), _c('a', {
    staticClass: "link",
    attrs: {
      "href": "#/ch03#chiff",
      "id": "d0e646"
    }
  }, [_vm._v("chiffonade")])]), _vm._v(" "), _c('p', {
    staticClass: "nospace"
  }, [_vm._v("Zest of 1 lemon ")]), _vm._v(" "), _c('p', {
    staticClass: "nospace"
  }, [_vm._v("3 cups (360 g) panko bread crumbs ")]), _vm._v(" "), _c('p', {
    staticClass: "nospace"
  }, [_vm._v("1/2 cup (120 ml) vegetable oil ")]), _vm._v(" "), _c('p', {
    staticClass: "nospace"
  }, [_vm._v("1 tablespoon unsalted butter ")]), _vm._v(" "), _c('p', {
    staticClass: "nospace"
  }, [_vm._v("Kosher or sea salt and freshly ground pepper, to taste ")])]), _vm._v(" "), _c('p', [_vm._v("Stir together mashed potatoes, flour, egg yolk, ricotta, basil, and lemon zest in a\n                large bowl, combining thoroughly using a wooden spoon. Arrange the panko in a\n                shallow pan or bowl. Using either your own clean hands or a 1/2-cup (120-ml) ice\n                cream scoop, drop the mashed mixture into the panko crumbs and roll until the\n                potatoes are covered well. Ensure that the crumbs are fully embedded to form a\n                double-layer crust. Using your palms, press the cakes down into even round disks and\n                arrange on a baking sheet. Repeat until all of the cakes have been formed (about 8\n                cakes). Chill in refrigerator, covered, for at least 30 minutes (and up to 24 hours)\n                before frying. ")]), _vm._v(" "), _c('p', [_vm._v("Heat the oil and butter in a large nonstick skillet over medium-high heat until just\n                sizzling. Add 4 of the prepped cakes to the pan in a single layer with ample space\n                (a good 1/2 inch / 13 mm) between each cake. Lightly season the top of each with\n                salt and pepper. Reduce heat to medium and cook the cakes until golden, about 4\n                minutes. Flip each cake, being careful not to splatter the oil or tear the cakes.\n                Repeat cooking on the second side until golden, only 3 minutes this side. Remove\n                with a slotted spatula and drain on a paper towel–lined tray. Season lightly. Repeat\n                frying process with the second batch. Serve immediately, or reserve in a warm (200°\n                F / 95° C) oven up to 30 minutes before serving. Garnish with fresh basil leaves and\n                a lemon slice. ")]), _vm._v(" "), _c('div', {
    staticClass: "mediaobject",
    attrs: {
      "title": "Photo of Ricotta, Lemon, and Basil Potato Cakes."
    }
  }, [_c('img', {
    attrs: {
      "alt": "Photo of Ricotta, Lemon, and Basil Potato Cakes.",
      "src": "images/Ricotta%2c_Lemon_%26_Fresh_Basil_Potato_Cakes-8499-942.jpg"
    }
  })]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "id": "d0e667",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Two Potato and Ham Chowder with\n                Fresh Thyme ")])]), _c('a', {
    attrs: {
      "id": "d0e667",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_c('p', {
    staticClass: "yield"
  }, [_vm._v("Yields 8 to 10 servings ")]), _vm._v(" "), _c('p', [_vm._v("Starchy-turned-silky russet potatoes merge with traditional aromatic leek, onion,\n                garlic, and celery soup bedfellows; purée with cream and simmer again with colorful\n                chunks of waxy red potatoes and smoked ham bites to finish this luscious soup. A\n                smattering of fresh thyme announces a delicate lemony finish. If fatback is not\n                easily found where you live, substitute a few tablespoons of rendered bacon fat to\n                get things started. Save the crisped bacon to crumble over the finished soup before\n                serving. ")]), _vm._v(" "), _c('div', {
    staticClass: "simplelist"
  }, [_c('p', {
    staticClass: "nospace"
  }, [_vm._v("4 (1/2-inch / 13-mm) wide strips fatback, well-rinsed of\n                    additional exterior salt ")]), _vm._v(" "), _c('p', {
    staticClass: "nospace"
  }, [_vm._v("2 tablespoons unsalted butter ")]), _vm._v(" "), _c('p', {
    staticClass: "nospace"
  }, [_vm._v("2 leeks, well-rinsed white base only, trimmed and cut into\n                    1/2-inch (13-mm) dice (about 2 cups / 180 g) ")]), _vm._v(" "), _c('p', {
    staticClass: "nospace"
  }, [_vm._v("1 medium onion, cut into medium dice (about 3/4 cup / 113 g) ")]), _vm._v(" "), _c('p', {
    staticClass: "nospace"
  }, [_vm._v("3 cloves garlic, smashed and coarsely chopped ")]), _vm._v(" "), _c('p', {
    staticClass: "nospace"
  }, [_vm._v("1 large stalk celery, cleaned and cut into coarse 1/2-inch\n                    (13-mm) dice (about 2 cups / 200 g) ")]), _vm._v(" "), _c('p', {
    staticClass: "nospace"
  }, [_vm._v("2 teaspoons kosher or sea salt, divided ")]), _vm._v(" "), _c('p', {
    staticClass: "nospace"
  }, [_vm._v("1-1/2 teaspoons ground black pepper, divided ")]), _vm._v(" "), _c('p', {
    staticClass: "nospace"
  }, [_vm._v("5 to 6 small to medium russet potatoes, peeled and cut into\n                    1-inch (2.5-cm) dice (about 4 cups / 720 g) ")]), _vm._v(" "), _c('p', {
    staticClass: "nospace"
  }, [_vm._v("1 to 2 tablespoons sweet vermouth ")]), _vm._v(" "), _c('p', {
    staticClass: "nospace"
  }, [_vm._v("4 cups (960 ml) low-sodium chicken stock ")]), _vm._v(" "), _c('p', {
    staticClass: "nospace"
  }, [_vm._v("1/2 pound (230 g) boneless smoked ham steak, cut into 1/4-inch\n                    (6-mm) dice (about 2-1/2 cups / 450 g) ")]), _vm._v(" "), _c('p', {
    staticClass: "nospace"
  }, [_vm._v("2 medium waxy red potatoes, unpeeled and well-scrubbed, cut into\n                    1/4-inch (6-mm) dice (about 2 cups / 360 g) ")]), _vm._v(" "), _c('p', {
    staticClass: "nospace"
  }, [_vm._v("2 tablespoons finely chopped fresh thyme ")]), _vm._v(" "), _c('p', {
    staticClass: "nospace"
  }, [_vm._v("1 cup (240 ml) half-and-half ")]), _vm._v(" "), _c('p', {
    staticClass: "nospace"
  }, [_vm._v("1 cup (240 ml) whole milk ")]), _vm._v(" "), _c('p', {
    staticClass: "nospace"
  }, [_vm._v("2 tablespoons unsalted butter")])]), _vm._v(" "), _c('p', [_vm._v("Heat a 5-1/2-quart (5-l) heavy-bottom pot over medium heat. Add fatback and butter\n                and heat together until butter is melted. Add leeks, onion, garlic, celery, 1\n                teaspoon salt, and 1/2 teaspoon pepper. Stir to coat. Continue cooking over medium\n                heat until the vegetables have softened, about 5 minutes. Add the russet potatoes,\n                vermouth, and chicken stock. Bring to a boil over high heat, reduce to a simmer over\n                medium-low heat, and cook, uncovered, for 20 minutes, or until the potatoes are very\n                tender and falling apart. Remove fatback and discard. ")])]), _c('p', [_c('a', {
    attrs: {
      "id": "d0e667",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Using an immersion blender (")]), _c('a', {
    staticClass: "link",
    attrs: {
      "href": "#/ch02#bmasht",
      "id": "d0e712"
    }
  }, [_vm._v("Basic\n                    Mashing Tools")]), _vm._v(") or traditional blender, purée until very smooth. For a\n                chunkier, more rustic version, a thorough mash with a manual masher ("), _c('a', {
    staticClass: "link",
    attrs: {
      "href": "#/ch02#bmasht",
      "id": "d0e715"
    }
  }, [_vm._v("Basic Mashing Tools")]), _vm._v(") is also an\n                excellent option. In the same pot, add the ham, red potatoes, thyme, half-and-half,\n                milk, remaining salt, and remaining pepper. Bring to a boil over high heat and\n                reduce to medium low, cooking uncovered, stirring occasionally, until the red\n                potatoes are very tender, about 20 minutes. ")]), _vm._v(" "), _c('p', [_vm._v("Add butter just before serving and stir through until melted. Serve hot with fresh\n                thyme sprigs for garnish. The soup stores very well covered and refrigerated for up\n                to 3 days. Add extra cream or milk, as needed, to reheat. ")]), _vm._v(" "), _c('div', {
    staticClass: "mediaobject",
    attrs: {
      "title": "Photo of Two Potato and Ham Chowder with Fresh Thyme."
    }
  }, [_c('img', {
    attrs: {
      "alt": "Photo of Two Potato and Ham Chowder with Fresh Thyme.",
      "src": "images/Two_Potato_%26_Ham_Chowder_with_Fresh_Thyme--957.jpg"
    }
  })]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "id": "d0e725",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Salmon and Chive Mashed Potatoes ")])]), _c('a', {
    attrs: {
      "id": "d0e725",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_c('p', {
    staticClass: "yield"
  }, [_vm._v("Yields 8 servings ")]), _vm._v(" "), _c('p', [_vm._v("Pink flecks of canned salmon and green spots of fresh chives wink fresh spring spunk\n                and flavor into this beautiful bowl of spuds. ")])]), _c('div', {
    staticClass: "simplelist"
  }, [_c('a', {
    attrs: {
      "id": "d0e725",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }), _c('p', {
    staticClass: "nospace"
  }, [_c('a', {
    attrs: {
      "id": "d0e725",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("1 full recipe Ultimate Mashed Potatoes ")]), _c('a', {
    staticClass: "link",
    attrs: {
      "href": "#/ch04#masterrv",
      "id": "d0e734",
      "title": "Ultimate Mashed Potatoes Master Recipe—Rustic Version"
    }
  }, [_vm._v("Master\n                        Recipe—Rustic Version")])]), _vm._v(" "), _c('p', {
    staticClass: "nospace"
  }, [_vm._v("1 (5-ounce / 140-g) can boneless pink salmon, drained ")]), _vm._v(" "), _c('p', {
    staticClass: "nospace"
  }, [_vm._v("1/4 cup (10 g) finely chopped fresh chives ")])]), _vm._v(" "), _c('p', [_vm._v("Prepare the mashed potatoes as per directions. Mash in the salmon with a manual\n                masher ("), _c('a', {
    staticClass: "link",
    attrs: {
      "href": "#/ch02#bmasht",
      "id": "d0e742"
    }
  }, [_vm._v("Basic Mashing\n                Tools")]), _vm._v("). Fold in the chives. Serve hot. These potatoes are delicious as a meal\n                with a green salad on the side. ")]), _vm._v(" "), _c('div', {
    staticClass: "mediaobject",
    attrs: {
      "title": "Photo of Salmon and Chive Mashed Potatoes."
    }
  }, [_c('img', {
    attrs: {
      "alt": "Photo of Salmon and Chive Mashed Potatoes.",
      "src": "images/Salmon_%26_Chive_Mashed_Potatoes-9373-Edit-Edit-Edit-923.jpg"
    }
  })]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "id": "d0e750",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Smashed Gouda and Rosemary\n                Crusted Baby Yellow Potatoes ")])]), _c('a', {
    attrs: {
      "id": "d0e750",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_c('p', {
    staticClass: "yield"
  }, [_vm._v("Yields 4 to 6 servings ")]), _vm._v(" "), _c('p', [_vm._v("The thin skins of these waxy, slightly sweet, dense potatoes (you can substitute red\n                or white varieties), pop with a gentle smash from the masher after they are braised\n                to tenderness in stock. Browning in butter on both sides before drizzling with fresh\n                rosemary and smoky Gouda cheese for a quick, bubbly broil add an inviting crunch\n                factor and gooey cheese to every bite. Reminiscent of particularly indulgent potato\n                skins, they are lovely with pork chops or roasted chicken. ")]), _vm._v(" "), _c('div', {
    staticClass: "simplelist"
  }, [_c('p', {
    staticClass: "nospace"
  }, [_vm._v("18 to 20 baby yellow potatoes, 1 to 2 inches (2.5 to 5 cm) thick,\n                    scrubbed and pierced once with a knife ")]), _vm._v(" "), _c('p', {
    staticClass: "nospace"
  }, [_vm._v("2 cups (480 ml) chicken stock ")]), _vm._v(" "), _c('p', {
    staticClass: "nospace"
  }, [_vm._v("2 sprigs fresh rosemary ")]), _vm._v(" "), _c('p', {
    staticClass: "nospace"
  }, [_vm._v("1/4 teaspoon kosher or sea salt ")]), _vm._v(" "), _c('p', {
    staticClass: "nospace"
  }, [_vm._v("4 tablespoons unsalted butter, divided ")]), _vm._v(" "), _c('p', {
    staticClass: "nospace"
  }, [_vm._v("1/2 cup (120 ml) water ")]), _vm._v(" "), _c('p', {
    staticClass: "nospace"
  }, [_vm._v("1 tablespoon finely chopped fresh rosemary ")]), _vm._v(" "), _c('p', {
    staticClass: "nospace"
  }, [_vm._v("1 cup (60 g) grated smoked Gouda cheese or sharp cheddar ")]), _vm._v(" "), _c('p', {
    staticClass: "nospace"
  }, [_vm._v("1/2 teaspoon ground black pepper ")]), _vm._v(" "), _c('p', {
    staticClass: "nospace"
  }, [_vm._v("Sour cream")])]), _vm._v(" "), _c('p', [_vm._v("Cut any of the potatoes that are noticeably larger than the others down to a roughly\n                equivalent size. Arrange the potatoes in a single layer in a large ovenproof sauté\n                pan. Pour in the chicken stock, adding just enough to cover halfway. Tuck the\n                rosemary sprigs into the liquid and add salt. Bring to a boil over high, reduce to\n                simmer over low, and cover, cooking for 10 minutes. Turn the potatoes over, cover,\n                and cook on low for another 10 minutes, or until very tender. Remove cover and\n                discard rosemary sprigs. Increase heat to high and cook off any remaining stock,\n                uncovered, about 10 minutes. ")])]), _c('p', [_c('a', {
    attrs: {
      "id": "d0e750",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Meanwhile, preheat broiler to high. When the liquid in the potato pan is down to a\n                glaze, add 2 tablespoons butter. Swish to melt and reach the bottoms of all the\n                potatoes. Reduce heat to medium, add remaining butter, swishing to coat, and leave\n                untouched for 4 minutes, until potatoes are caramelized and golden on the bottom.\n                Turn each potato over and smash individually, pressing down gently with a manual\n                masher (")]), _c('a', {
    staticClass: "link",
    attrs: {
      "href": "#/ch02#bmasht",
      "id": "d0e781"
    }
  }, [_vm._v("Basic Mashing Tools")]), _vm._v(")\n                until they flatten to about 1/2 inch (13 mm) thick and pop. Add water to deglaze\n                pan. Sprinkle the top of the potatoes with rosemary, cheese, and pepper. Broil for\n                3–5 minutes until bubbly and golden. Serve immediately with a dollop of sour cream\n                on each serving, if desired. ")]), _vm._v(" "), _c('div', {
    staticClass: "mediaobject",
    attrs: {
      "title": "Photo of Smashed Gouda and Rosemary Crusted Baby Yellow Potatoes."
    }
  }, [_c('img', {
    attrs: {
      "alt": "Photo of Smashed Gouda and Rosemary Crusted Baby Yellow Potatoes.",
      "src": "images/Smashed_Gouda_%26_Rosemary_Baby_Yellow_Potatoes--950.jpg"
    }
  })]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "id": "tcelery",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Triple-Threat Celery Mash ")])]), _c('a', {
    attrs: {
      "id": "tcelery",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_c('p', {
    staticClass: "yield"
  }, [_vm._v("Yields 8 servings ")]), _vm._v(" "), _c('p', [_vm._v("When living in France decades ago, I discovered celery root, or celeriac, which is\n                the bulb that yields the stalks that yield the leaves, all of which have wonderfully\n                distinct and varied levels of celery flavor. The crunch and the freshness of the\n                stalks, the fluttery light aroma of the leaves, and the layered buttery celery\n                essence of the root all come together in one place in this magnificent dish. Its\n                gamy vegetable flavor would work magic with roasted rabbit, duck, goose, or\n                venison—making it an almost automatic annual holiday table showstopper! ")])]), _c('div', {
    staticClass: "simplelist"
  }, [_c('a', {
    attrs: {
      "id": "tcelery",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }), _c('p', {
    staticClass: "nospace"
  }, [_c('a', {
    attrs: {
      "id": "tcelery",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("1 large ")]), _c('a', {
    staticClass: "link",
    attrs: {
      "href": "#/ch03#croot",
      "id": "d0e798"
    }
  }, [_vm._v("celery\n                        root")]), _vm._v(", rough outer skin and inner skin removed and discarded, cut into\n                    1-inch (2.5-cm) cubes (about 4 cups / 400 g) ")]), _vm._v(" "), _c('p', {
    staticClass: "nospace"
  }, [_vm._v("2 medium russet potatoes, peeled and cut into 1-inch (2.5-cm)\n                    cubes (about 2 cups / 360 g) ")]), _vm._v(" "), _c('p', {
    staticClass: "nospace"
  }, [_vm._v("2 stalks celery, trimmed, cleaned, and cut into 1-inch (2.5-cm)\n                    lengths ")]), _vm._v(" "), _c('p', {
    staticClass: "nospace"
  }, [_vm._v("Water ")]), _vm._v(" "), _c('p', {
    staticClass: "nospace"
  }, [_vm._v("1 tablespoon kosher or sea salt ")]), _vm._v(" "), _c('p', {
    staticClass: "nospace"
  }, [_vm._v("1 cup (240 ml) heavy cream ")]), _vm._v(" "), _c('p', {
    staticClass: "nospace"
  }, [_vm._v("3 tablespoons butter ")]), _vm._v(" "), _c('p', {
    staticClass: "nospace"
  }, [_vm._v("1 teaspoon celery seed ")]), _vm._v(" "), _c('p', {
    staticClass: "nospace"
  }, [_vm._v("2 tablespoons unsalted butter ")]), _vm._v(" "), _c('p', {
    staticClass: "nospace"
  }, [_vm._v("1 teaspoon kosher or sea salt ")]), _vm._v(" "), _c('p', {
    staticClass: "nospace"
  }, [_vm._v("1/2 teaspoon ground black pepper ")]), _vm._v(" "), _c('p', {
    staticClass: "nospace"
  }, [_vm._v("Finely chopped celery leaves ")])]), _vm._v(" "), _c('p', [_vm._v("Place the celery root, potatoes, and celery in a medium pot. Cover generously with\n                cold water. Add 1 tablespoon salt. Bring to a boil over high and reduce to a simmer\n                over medium-low heat. Cook, uncovered, for 30 minutes, or until all ingredients are\n                very tender when pierced with a knife. Drain thoroughly in a colander and return to\n                the warm cooking pot. Heat the celery mixture over medium heat for 1–2 minutes,\n                shaking to move around the pan and dry out the ingredients. ")]), _vm._v(" "), _c('p', [_vm._v("Heat the cream, butter, and celery seed in a saucepan or in the microwave until warm\n                and melted. Pour into the celery mixture, in thirds, mashing coarsely with a manual\n                masher ("), _c('a', {
    staticClass: "link",
    attrs: {
      "href": "#/ch02#bmasht",
      "id": "d0e827"
    }
  }, [_vm._v("Basic Mashing Tools")]), _vm._v(")\n                to combine and purée. Season with salt and pepper, tasting to adjust as needed.\n                Serve hot, and garnish with a few chopped celery leaves. The mash will store\n                beautifully in a sealed container in the refrigerator for up to 3 days. Reheat over\n                a water bath or in the microwave. ")]), _vm._v(" "), _c('div', {
    staticClass: "mediaobject",
    attrs: {
      "title": "Photo of Triple-Threat Celery Mash."
    }
  }, [_c('img', {
    attrs: {
      "alt": "Photo of Triple-Threat Celery Mash.",
      "src": "images/Triple_Threat_Celery_Mash-2-Edit-941.jpg"
    }
  })]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "id": "d0e835",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Smashed Baby Red Potatoes with\n                Garlic and Chives ")])]), _c('a', {
    attrs: {
      "id": "d0e835",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_c('p', {
    staticClass: "yield"
  }, [_vm._v("Yields 4 to 6 servings ")]), _vm._v(" "), _c('p', [_vm._v("These plucky little red potatoes are always at the ready in my pantry. They do almost\n                all the work as they simmer their way to tender along with a few cloves of garlic.\n                The finish in this recipe is fast and simple: a manual mash with lots of butter, a\n                dash of cream, salt, pepper, and a flurry of pungent fresh green chives. It’s the\n                perfect side for roasted chicken, burgers, or a steak. They reheat just as easily in\n                the microwave (though it will alter the texture just slightly) as they do over a\n                water bath. ")]), _vm._v(" "), _c('div', {
    staticClass: "simplelist"
  }, [_c('p', {
    staticClass: "nospace"
  }, [_vm._v("About 24 (2 cups / 360 g) unpeeled and scrubbed baby red\n                    potatoes* ")]), _vm._v(" "), _c('p', {
    staticClass: "nospace"
  }, [_vm._v("4 large cloves garlic, peeled and smashed ")]), _vm._v(" "), _c('p', {
    staticClass: "nospace"
  }, [_vm._v("1 tablespoon kosher or sea salt ")]), _vm._v(" "), _c('p', {
    staticClass: "nospace"
  }, [_vm._v("Water ")]), _vm._v(" "), _c('p', {
    staticClass: "nospace"
  }, [_vm._v("1 cup (240 ml) half-and-half ")]), _vm._v(" "), _c('p', {
    staticClass: "nospace"
  }, [_vm._v("4 tablespoons unsalted butter ")]), _vm._v(" "), _c('p', {
    staticClass: "nospace"
  }, [_vm._v("1 teaspoon kosher or sea salt ")]), _vm._v(" "), _c('p', {
    staticClass: "nospace"
  }, [_vm._v("1 teaspoon ground black pepper ")]), _vm._v(" "), _c('p', {
    staticClass: "nospace"
  }, [_vm._v("1/4 cup (13 g) finely chopped fresh chives ")])]), _vm._v(" "), _c('p', [_vm._v("Place the potatoes in a medium pot with garlic, 1 tablespoon salt, and enough water\n                to cover. Bring to a boil over high heat, uncovered, and reduce to a simmer over\n                medium low. Cook until the potatoes are very tender when pierced with a knife, about\n                25 minutes. Drain well in a colander. ")])]), _c('p', [_c('a', {
    attrs: {
      "id": "d0e835",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Heat together the half-and-half and butter in a saucepan or in the microwave until\n                melted and warm. Return the potatoes to the cooking pot. Drizzle in the warmed cream\n                and butter, mashing with a manual masher (")]), _c('a', {
    staticClass: "link",
    attrs: {
      "href": "#/ch02#bmasht",
      "id": "d0e864"
    }
  }, [_vm._v("Basic Mashing Tools")]), _vm._v("). You’re shooting for a fat, chunky texture.\n                A few mashes and swirls will do. Add the salt and pepper and combine. Gently fold in\n                the fresh chives just before serving. Taste and adjust seasoning as needed. Serve\n                steaming hot. ")]), _vm._v(" "), _c('p', [_vm._v("*The potatoes will be about the diameter of a quarter. Cut any that are noticeably\n                larger so that all are about the same size and will cook evenly. ")]), _vm._v(" "), _c('div', {
    staticClass: "mediaobject",
    attrs: {
      "title": "Photo of Smashed Baby Red Potatoes with Garlic and Chives."
    }
  }, [_c('img', {
    attrs: {
      "alt": "Photo of Smashed Baby Red Potatoes with Garlic and Chives.",
      "src": "images/Smashed_Buttery_Baby_Red_Potatoes_with_Garlic-9250-Edit-3-Edit-925.jpg"
    }
  })]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "id": "d0e874",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Cauliflower Mashed Potatoes ")])]), _c('a', {
    attrs: {
      "id": "d0e874",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_c('p', {
    staticClass: "yield"
  }, [_vm._v("Yields 6 servings ")]), _vm._v(" "), _c('p', [_vm._v("Cauliflower practically melts into the reduced quantity of potatoes in this delicate\n                mash, fooling even the most practiced palate into believing they’re eating 100\n                percent potatoes. Great for lower carb and calorie dining, this fluffy, aerated mash\n                also takes less cream due to the higher moisture content of the cauliflower. Serve\n                with salmon or another mild fish, like cod or flounder, and a mound of lightly\n                dressed greens. ")]), _vm._v(" "), _c('div', {
    staticClass: "simplelist"
  }, [_c('p', {
    staticClass: "nospace"
  }, [_vm._v("1 head cauliflower, quartered, cored, and cut into medium florets\n                    (about 6 cups / 1.375 kg) ")]), _vm._v(" "), _c('p', {
    staticClass: "nospace"
  }, [_vm._v("2 large russet potatoes, peeled and cut into 2-inch (5-cm) chunks ")]), _vm._v(" "), _c('p', {
    staticClass: "nospace"
  }, [_vm._v("1 tablespoon kosher or sea salt ")]), _vm._v(" "), _c('p', {
    staticClass: "nospace"
  }, [_vm._v("Water ")]), _vm._v(" "), _c('p', {
    staticClass: "nospace"
  }, [_vm._v("3/4 to 1 cup (180 to 240 ml) half-and-half, warmed ")]), _vm._v(" "), _c('p', {
    staticClass: "nospace"
  }, [_vm._v("3 tablespoons unsalted butter ")]), _vm._v(" "), _c('p', {
    staticClass: "nospace"
  }, [_vm._v("1 teaspoon kosher or sea salt ")]), _vm._v(" "), _c('p', {
    staticClass: "nospace"
  }, [_vm._v("1/2 teaspoon ground black pepper")])]), _vm._v(" "), _c('p', [_vm._v("Place the cauliflower, potatoes, and salt in a large pot with just enough cold water\n                to cover. Bring to a boil over high heat, reduce to a simmer over medium-low heat,\n                and cook, uncovered, until tender, about 20 minutes. Drain well in a colander. ")])]), _c('p', [_c('a', {
    attrs: {
      "id": "d0e874",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Return the mixture to the cooking pot, stream in the half-and-half, and mash with a\n                manual masher (")]), _c('a', {
    staticClass: "link",
    attrs: {
      "href": "#/ch02#bmasht",
      "id": "d0e901"
    }
  }, [_vm._v("Basic Mashing\n                    Tools")]), _vm._v(") until chunky smooth. Stir in the butter, salt, and pepper. Taste and\n                adjust seasoning as needed. Serve very hot with additional pats of butter. This can\n                be made ahead and refrigerated, covered, for a day or two and gently reheated over\n                low heat or a water bath. ")]), _vm._v(" "), _c('div', {
    staticClass: "mediaobject",
    attrs: {
      "title": "Photo of Cauliflower Mashed Potatoes."
    }
  }, [_c('img', {
    attrs: {
      "alt": "Photo of Cauliflower Mashed Potatoes.",
      "src": "images/Cauliflower_Mashed_Potatoes-3-952.jpg"
    }
  })]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "id": "d0e909",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Italian Sausage, Pepper, and\n                Onion Potato Pie ")])]), _c('a', {
    attrs: {
      "id": "d0e909",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_c('p', {
    staticClass: "yield"
  }, [_vm._v("Yields 8 to 10 servings ")]), _vm._v(" "), _c('p', [_vm._v("This decadent, layered pie begins with a fat layer of mashed potatoes, a layer of\n                mozzarella, a big layer of sautéed sausage, peppers, and onions, and is finished\n                with more mozzarella. Hearty and comforting, it’s like an Italian/American potato\n                and cheese lasagna and requires a lot less work. ")])]), _c('div', {
    staticClass: "simplelist"
  }, [_c('a', {
    attrs: {
      "id": "d0e909",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_c('p', {
    staticClass: "nospace"
  }, [_vm._v("1 tablespoon butter, room temperature ")]), _vm._v(" "), _c('p', {
    staticClass: "nospace"
  }, [_vm._v("1 pound (450 g) loose regular breakfast sausage ")]), _vm._v(" "), _c('p', {
    staticClass: "nospace"
  }, [_vm._v("1 red bell pepper, halved, seeded, and cut into very thin strips ")]), _vm._v(" "), _c('p', {
    staticClass: "nospace"
  }, [_vm._v("1 green bell pepper, halved, seeded, and cut into very thin\n                    strips ")]), _vm._v(" "), _c('p', {
    staticClass: "nospace"
  }, [_vm._v("1 onion, peeled, halved, and cut into very thin strips ")]), _vm._v(" "), _c('p', {
    staticClass: "nospace"
  }, [_vm._v("1 clove garlic, smashed and finely chopped ")]), _vm._v(" "), _c('p', {
    staticClass: "nospace"
  }, [_vm._v("1 teaspoon fennel seeds ")]), _vm._v(" "), _c('p', {
    staticClass: "nospace"
  }, [_vm._v("2 teaspoons dried oregano ")]), _vm._v(" "), _c('p', {
    staticClass: "nospace"
  }, [_vm._v("1/2 teaspoon kosher or sea salt ")]), _vm._v(" "), _c('p', {
    staticClass: "nospace"
  }, [_vm._v("1 teaspoon ground black pepper ")]), _vm._v(" "), _c('p', {
    staticClass: "nospace"
  }, [_vm._v("1 tablespoon white wine, such as Chardonnay or Pinot Grigio, ")])]), _c('p', {
    staticClass: "nospace"
  }, [_c('a', {
    attrs: {
      "id": "d0e909",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("1/2 prepared recipe Ultimate Mashed Potatoes ")]), _c('a', {
    staticClass: "link",
    attrs: {
      "href": "#/ch04#masterrv",
      "id": "d0e940",
      "title": "Ultimate Mashed Potatoes Master Recipe—Rustic Version"
    }
  }, [_vm._v("Master\n                        Recipe—Rustic Version")]), _vm._v(") ")]), _vm._v(" "), _c('p', {
    staticClass: "nospace"
  }, [_vm._v("2 cups grated mozzarella, divided")])]), _vm._v(" "), _c('p', [_vm._v("Preheat oven to 375° F (190° C). Butter a 1.5-quart (1.5-l) deep casserole dish with\n                the room-temperature butter. ")]), _vm._v(" "), _c('p', [_vm._v("Crumble the sausage into a large sauté pan heated over medium heat. Cook, stirring\n                and breaking up with a wooden spoon, until browned, about 5 minutes. Add the bell\n                peppers, onion, garlic, fennel seeds, oregano, salt, and pepper. Cook, stirring over\n                medium-low heat, until the vegetables are very soft, about 20 minutes. Add the wine\n                and cook off to a glaze. Set aside. ")]), _vm._v(" "), _c('p', [_vm._v("To compile, place mashed potatoes into the casserole dish. Level off with a spatula.\n                Sprinkle 1 cup of the mozzarella over the top. Add the reserved sausage and pepper\n                combination and level off with a spatula. Sprinkle the remaining mozzarella over the\n                top. Bake for 25–30 minutes, or until the pie is bubbling and the cheese is melted\n                and golden. Serve very hot. ")]), _vm._v(" "), _c('div', {
    staticClass: "mediaobject",
    attrs: {
      "title": "Photo of Italian Sausage, Pepper, and Onion Potato Pie."
    }
  }, [_c('img', {
    attrs: {
      "alt": "Photo of Italian Sausage, Pepper, and Onion Potato Pie.",
      "src": "images/Italian_Sausage%2c_Pepper_%26_Onion_Potato_Pie-8965-Edit-Edit-934.jpg"
    }
  })]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "id": "d0e956",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Green Peas and Onion Mashed\n                Potatoes ")])]), _c('a', {
    attrs: {
      "id": "d0e956",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_c('p', {
    staticClass: "yield"
  }, [_vm._v("Yields 8 to 10 servings ")]), _vm._v(" "), _c('p', [_vm._v("Sweet peas and onion chunks dance in this spring-inspired potato mash. Add a bit of\n                fresh parsley and/or mint for additional spring pizzazz. This would be beautiful\n                with prime rib or a grilled steak. ")])]), _c('div', {
    staticClass: "simplelist"
  }, [_c('a', {
    attrs: {
      "id": "d0e956",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }), _c('p', {
    staticClass: "nospace"
  }, [_c('a', {
    attrs: {
      "id": "d0e956",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("1 full recipe Ultimate Mashed Potatoes ")]), _c('a', {
    staticClass: "link",
    attrs: {
      "href": "#/ch04#masterrv",
      "id": "d0e965",
      "title": "Ultimate Mashed Potatoes Master Recipe—Rustic Version"
    }
  }, [_vm._v("Master\n                        Recipe—Rustic Version")])]), _vm._v(" "), _c('p', {
    staticClass: "nospace"
  }, [_vm._v("1 small onion, peeled, halved, and thinly sliced ")]), _vm._v(" "), _c('p', {
    staticClass: "nospace"
  }, [_vm._v("2 cups (300 g) peas (fresh or frozen) ")]), _vm._v(" "), _c('p', {
    staticClass: "nospace"
  }, [_vm._v("1 teaspoon salt ")]), _vm._v(" "), _c('p', {
    staticClass: "nospace"
  }, [_vm._v("Water ")])]), _vm._v(" "), _c('p', [_vm._v("Prepare the mashed potatoes as per directions, adding the onion slices to the pot\n                along with the potatoes and water. Cook and mash as directed until chunky smooth. ")]), _vm._v(" "), _c('p', [_vm._v("Meanwhile, place the peas in a large pot with salt and water to cover. Bring to a\n                boil over high heat, reduce to a simmer, and cook for 10 minutes, or until the peas\n                are softened but still retain their shape. Drain in a colander and run very cold\n                water over them to stop the cooking and maintain the brilliant green color. Gently\n                fold the peas into the warm potatoes and heat through over low heat. Serve hot. ")]), _vm._v(" "), _c('div', {
    staticClass: "mediaobject",
    attrs: {
      "title": "Photo of Green Peas and Onion Mashed Potatoes."
    }
  }, [_c('img', {
    attrs: {
      "alt": "Photo of Green Peas and Onion Mashed Potatoes.",
      "src": "images/Green_Peas_%26_Onion_Mashed_Potatoes_--946.jpg"
    }
  })]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "id": "d0e985",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Potato and Spinach Phyllo Bites ")])]), _c('a', {
    attrs: {
      "id": "d0e985",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_c('p', {
    staticClass: "yield"
  }, [_vm._v("Yields 24 to 26 appetizers ")]), _vm._v(" "), _c('p', [_vm._v("Crispy, golden Greek phyllo pastry encases petite pillows of baked, riced potatoes\n                with sautéed spinach and a generous dash of nutmeg in this wonderful dish. Phyllo\n                can be difficult to work with, but if you follow the package directions (I like\n                Athens brand) to thaw it in the refrigerator and keep it damp with a towel while\n                you’re working, it will comply. Rather than deal with folding the pastry into\n                repeated triangles or complicated forms, here the filling is rolled with the pastry\n                into little logs with crimped ends—resembling hard candy wrappers. The pastry ends\n                become golden and crunchy and the inside puffy and delicious. These can be prepped\n                ahead entirely and baked just before serving, which makes them delicious,\n                hostess-friendly fare. ")])]), _c('div', {
    staticClass: "simplelist"
  }, [_c('a', {
    attrs: {
      "id": "d0e985",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_c('p', {
    staticClass: "nospace"
  }, [_vm._v("2 tablespoons unsalted butter ")]), _vm._v(" "), _c('p', {
    staticClass: "nospace"
  }, [_vm._v("1/2 cup (75 g) finely chopped red onion ")]), _vm._v(" "), _c('p', {
    staticClass: "nospace"
  }, [_vm._v("1-1/2 cups (230 g) thawed frozen chopped spinach ")]), _vm._v(" "), _c('p', {
    staticClass: "nospace"
  }, [_vm._v("1 teaspoon kosher or sea salt ")]), _vm._v(" "), _c('p', {
    staticClass: "nospace"
  }, [_vm._v("1/2 teaspoon ground black pepper ")]), _vm._v(" "), _c('p', {
    staticClass: "nospace"
  }, [_vm._v("1/2 teaspoon ground nutmeg ")])]), _c('p', {
    staticClass: "nospace"
  }, [_c('a', {
    attrs: {
      "id": "d0e985",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("2 cups (320 g) ")]), _c('a', {
    staticClass: "link",
    attrs: {
      "href": "#/ch04#riced",
      "id": "d0e1006",
      "title": "Basic Riced Potatoes"
    }
  }, [_vm._v("Basic Riced Potatoes")])]), _vm._v(" "), _c('p', {
    staticClass: "nospace"
  }, [_vm._v("1 egg, beaten ")]), _vm._v(" "), _c('p', {
    staticClass: "nospace"
  }, [_vm._v("1 teaspoon kosher or sea salt ")]), _vm._v(" "), _c('p', {
    staticClass: "nospace"
  }, [_vm._v("1/2 teaspoon ground black pepper ")]), _vm._v(" "), _c('p', {
    staticClass: "nospace"
  }, [_vm._v("1 full roll (1/2 package) phyllo dough, thawed, unrolled, and cut\n                    vertically into 3 (4-inch / 10-cm) wide layers, covered with a damp towel ")]), _vm._v(" "), _c('p', {
    staticClass: "nospace"
  }, [_vm._v("4 tablespoons unsalted butter, melted")])]), _vm._v(" "), _c('p', [_vm._v("Preheat oven to 375° F (190° C). Melt 2 tablespoons butter with the onion in a large\n                sauté pan over medium heat until softened, about 5 minutes. Stir in the spinach,\n                salt, pepper, and nutmeg. Reduce heat to low and cook until tender and most of the\n                liquid has evaporated, 5–7 minutes. Set aside. ")]), _vm._v(" "), _c('p', [_vm._v("In a medium bowl, combine the potatoes, egg, salt, and pepper with a wooden spoon.\n                Stir in the reserved spinach mixture until well incorporated. Cover and refrigerate\n                for 15 minutes (or overnight to fill and bake the following day). ")]), _vm._v(" "), _c('p', [_vm._v("To fill the phyllo, gently pull 2 layers of the pastry from the stack. Using a pastry\n                brush and the melted butter, generously butter the top layer. Place 1 tablespoon of\n                the filling at the very end of the buttered layer, leaving about 1/4 inch (6 mm)\n                free space on each side of the filling. Roll gently, as you would a cigar, until\n                sealed. Twist the free ends as you would a hard candy wrapper. Place seam side down\n                on a rimmed baking sheet. Continue with the rest until completed, spacing\n                generously. Brush the tops and ends of each lightly with remaining butter and\n                sprinkle lightly with salt. Bake for 30 minutes, or until golden brown. Arrange on a\n                serving platter and serve hot. ")]), _vm._v(" "), _c('div', {
    staticClass: "mediaobject",
    attrs: {
      "title": "Photo of Potato and Spinach Phyllo Bites."
    }
  }, [_c('img', {
    attrs: {
      "alt": "Photo of Potato and Spinach Phyllo Bites.",
      "src": "images/Potato_%26_Spinach_Phyllo_Bites_-74-916.jpg"
    }
  })]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "id": "cbcskins",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Cheddar-Bacon-Celery Skins ")])]), _c('a', {
    attrs: {
      "id": "cbcskins",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_c('p', {
    staticClass: "yield"
  }, [_vm._v("Yields 16 appetizers ")]), _vm._v(" "), _c('p', [_vm._v("Who doesn’t love an ooey-gooey, crispy, delicious potato skin to go with a great\n                football game? These skins get a triple crisp—the initial bake, a second hollowed\n                and buttered bake, a thin layer of leftover mashed potatoes, and then a final bake\n                in a very hot oven. Their garnish is simply grated cheddar cheese, some bacon, and a\n                surprise base layer of diced celery. A dollop of tangy, cool sour cream scores every\n                time. ")])]), _c('div', {
    staticClass: "simplelist"
  }, [_c('a', {
    attrs: {
      "id": "cbcskins",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }), _c('p', {
    staticClass: "nospace"
  }, [_c('a', {
    attrs: {
      "id": "cbcskins",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("16 hollowed baked potato skins (reserved from ")]), _c('a', {
    staticClass: "link",
    attrs: {
      "href": "#/ch04#riced",
      "id": "d0e1039",
      "title": "Basic Riced Potatoes"
    }
  }, [_vm._v("Basic Riced\n                        Potatoes")]), _vm._v(") ")]), _vm._v(" "), _c('p', {
    staticClass: "nospace"
  }, [_vm._v("2 tablespoons unsalted butter, melted ")]), _vm._v(" "), _c('p', {
    staticClass: "nospace"
  }, [_vm._v("Kosher or sea salt and ground black pepper ")]), _vm._v(" "), _c('p', {
    staticClass: "nospace"
  }, [_vm._v("1 cup leftover mashed potatoes ")]), _vm._v(" "), _c('p', {
    staticClass: "nospace"
  }, [_vm._v("1/2 cup (50 g) very finely chopped celery ")]), _vm._v(" "), _c('p', {
    staticClass: "nospace"
  }, [_vm._v("8 strips bacon, fried or baked until crispy, drained on paper\n                    towels, and coarsely chopped ")]), _vm._v(" "), _c('p', {
    staticClass: "nospace"
  }, [_vm._v("1 cup (120 g) grated cheddar cheese ")]), _vm._v(" "), _c('p', {
    staticClass: "nospace"
  }, [_vm._v("Sour cream")])]), _vm._v(" "), _c('p', [_vm._v("Preheat oven to 500° F (260° C). Brush the skins with the butter and arrange on a\n                baking sheet. Season each lightly with salt and pepper. Bake until crisp and golden,\n                about 5 minutes. Remove from oven. ")]), _vm._v(" "), _c('p', [_vm._v("To fill, spoon in about 1 tablespoon of the mashed potatoes and level, sprinkle a few\n                pieces of celery, top with a thin layer of bacon, and finally add about 1 tablespoon\n                of cheese in each potato skin. Repeat. Sprinkle any remaining bacon on top, and bake\n                until bubbly and hot, 8–10 minutes. Serve hot and don’t forget to pass the sour\n                cream. ")]), _vm._v(" "), _c('div', {
    staticClass: "mediaobject",
    attrs: {
      "title": "Photo of Cheddar-Bacon-Celery Skins."
    }
  }, [_c('img', {
    attrs: {
      "alt": "Photo of Cheddar-Bacon-Celery Skins.",
      "src": "images/Cheddar_Bacon_Celery_Skins--951.jpg"
    }
  })]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "id": "d0e1065",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Potato, Corn, and Salmon Muffin\n                Cakes ")])]), _c('a', {
    attrs: {
      "id": "d0e1065",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_c('p', {
    staticClass: "yield"
  }, [_vm._v("Yields 24 mini muffin cakes ")]), _vm._v(" "), _c('p', [_vm._v("Perfect party fare, these airy cakes can be prepped fully in advance and baked at the\n                last minute. Bake in mini muffin pans or spoon into a buttered baking pan for a more\n                casual look with just a little less work. ")])]), _c('div', {
    staticClass: "simplelist"
  }, [_c('a', {
    attrs: {
      "id": "d0e1065",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_c('p', {
    staticClass: "nospace"
  }, [_vm._v("2 tablespoons unsalted butter, room temperature ")])]), _c('p', {
    staticClass: "nospace"
  }, [_c('a', {
    attrs: {
      "id": "d0e1065",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("2 cups (120 g) ")]), _c('a', {
    staticClass: "link",
    attrs: {
      "href": "#/ch04#riced",
      "id": "d0e1076",
      "title": "Basic Riced Potatoes"
    }
  }, [_vm._v("Basic Riced Potatoes")])]), _vm._v(" "), _c('p', {
    staticClass: "nospace"
  }, [_vm._v("1 large egg, beaten ")]), _vm._v(" "), _c('p', {
    staticClass: "nospace"
  }, [_vm._v("1/2 cup (60 g) full-fat ricotta ")]), _vm._v(" "), _c('p', {
    staticClass: "nospace"
  }, [_vm._v("1 teaspoon kosher or sea salt ")]), _vm._v(" "), _c('p', {
    staticClass: "nospace"
  }, [_vm._v("1/2 teaspoon ground black pepper ")]), _vm._v(" "), _c('p', {
    staticClass: "nospace"
  }, [_vm._v("1 cup (150 g) canned corn kernels, well-drained ")]), _vm._v(" "), _c('p', {
    staticClass: "nospace"
  }, [_vm._v("1 cup (140 g) skinless, boneless canned pink salmon, well-drained\n                    (fresh salmon can be used) ")]), _vm._v(" "), _c('p', {
    staticClass: "nospace"
  }, [_vm._v("1 teaspoon fresh lemon zest ")]), _vm._v(" "), _c('p', {
    staticClass: "nospace"
  }, [_vm._v("1/4 cup (10 g) finely chopped fresh parsley ")]), _vm._v(" "), _c('p', {
    staticClass: "nospace"
  }, [_vm._v("2 tablespoons unsalted butter, melted ")]), _vm._v(" "), _c('p', {
    staticClass: "nospace"
  }, [_vm._v("Fresh lemon juice")])]), _vm._v(" "), _c('p', [_vm._v("Preheat oven to 400° F (205° C). Generously butter the cups of a 24 mini muffin pan\n                with 2 tablespoons butter. Using a wooden spoon, combine the potatoes with the egg,\n                ricotta, salt, and pepper until fully incorporated. Add the corn, salmon, lemon\n                zest, and parsley, folding to combine. ")]), _vm._v(" "), _c('p', [_vm._v("Place about 2 tablespoons of the filling into each muffin cup. Press the top of each\n                to compress and flatten slightly. Brush each with a light coating of melted butter.\n                Bake for 40 minutes, or until golden and slightly puffed. Remove from oven and let\n                rest for 5 minutes. Using the edge of a spoon or pastry spatula, gently remove the\n                muffins from the pan and arrange on a serving platter. Serve hot. If desired,\n                squeeze a little fresh lemon juice over the tops while still very hot, and just\n                before serving. ")]), _vm._v(" "), _c('div', {
    staticClass: "mediaobject",
    attrs: {
      "title": "Photo of Potato, Corn, and Salmon Muffin Cakes."
    }
  }, [_c('img', {
    attrs: {
      "alt": "Photo of Potato, Corn, and Salmon Muffin Cakes.",
      "src": "images/Potato%2c_Corn_%26_Salmon_Muffin_Cakes-8601-Edit-940.jpg"
    }
  })]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "id": "d0e1108",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Simply Sweet Potato Soup ")])]), _c('a', {
    attrs: {
      "id": "d0e1108",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_c('p', {
    staticClass: "yield"
  }, [_vm._v("Yields 6 to 8 servings ")]), _vm._v(" "), _c('p', [_vm._v("Sweet potatoes are too frequently loaded with cream, fat, and sugar that mask their\n                subtle natural flavor and pile on calories. Not so in this silky soup where sweet\n                potatoes simmer with complementary vegetable cousins, carrots, celery, and onion.\n                The soup is finished with a whisper of cream, rendering it quite possibly the most\n                delicious potato soup you will ever have the pleasure of eating. You can make it\n                ahead and refrigerate or freeze, reheat, and add the cream just before serving. ")]), _vm._v(" "), _c('div', {
    staticClass: "simplelist"
  }, [_c('p', {
    staticClass: "nospace"
  }, [_vm._v("1 tablespoon rendered bacon fat or unsalted butter ")]), _vm._v(" "), _c('p', {
    staticClass: "nospace"
  }, [_vm._v("2 stalks celery, trimmed and cut into medium dice (about 1 cup /\n                    100 g) ")]), _vm._v(" "), _c('p', {
    staticClass: "nospace"
  }, [_vm._v("2 small carrots, peeled and cut into medium dice (about 1 cup /\n                    130 g) ")]), _vm._v(" "), _c('p', {
    staticClass: "nospace"
  }, [_vm._v("1 medium onion, peeled and cut into medium dice (about 1 cup /\n                    150 g) ")]), _vm._v(" "), _c('p', {
    staticClass: "nospace"
  }, [_vm._v("1 teaspoon kosher or sea salt ")]), _vm._v(" "), _c('p', {
    staticClass: "nospace"
  }, [_vm._v("1/2 teaspoon ground black pepper ")]), _vm._v(" "), _c('p', {
    staticClass: "nospace"
  }, [_vm._v("1 teaspoon ground ginger ")]), _vm._v(" "), _c('p', {
    staticClass: "nospace"
  }, [_vm._v("1/2 teaspoon ground allspice ")]), _vm._v(" "), _c('p', {
    staticClass: "nospace"
  }, [_vm._v("1 teaspoon ground cinnamon ")]), _vm._v(" "), _c('p', {
    staticClass: "nospace"
  }, [_vm._v("2 large sweet potatoes, peeled and cut into 1-inch (2.5-cm) cubes\n                    (about 3 cups / 540 g) ")]), _vm._v(" "), _c('p', {
    staticClass: "nospace"
  }, [_vm._v("6 cups (1.4 l) low-sodium chicken stock ")]), _vm._v(" "), _c('p', {
    staticClass: "nospace"
  }, [_vm._v("2 to 3 tablespoons honey ")]), _vm._v(" "), _c('p', {
    staticClass: "nospace"
  }, [_vm._v("1 tablespoon heavy cream ")])]), _vm._v(" "), _c('p', [_vm._v("In a large heavy-bottom pot, melt the bacon fat over medium heat. Add the celery,\n                carrots, onion, salt, pepper, ginger, allspice, and cinnamon. Stir to coat. Cook\n                over medium until just softened and fragrant, about 5 minutes. Add the sweet\n                potatoes and stock. Bring to a boil over high heat, reduce heat to low, and simmer\n                gently, uncovered, until the potatoes are very tender and falling apart. Remove from\n                the heat. ")])]), _c('p', [_c('a', {
    attrs: {
      "id": "d0e1108",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Purée with an immersion blender (")]), _c('a', {
    staticClass: "link",
    attrs: {
      "href": "#/ch02#bmasht",
      "id": "d0e1145"
    }
  }, [_vm._v("Basic Mashing Tools")]), _vm._v(") in the same pan until frothy and very smooth. Or, for\n                an even earthier, more rustic version, mash with a manual masher ("), _c('a', {
    staticClass: "link",
    attrs: {
      "href": "#/ch02#bmasht",
      "id": "d0e1148"
    }
  }, [_vm._v("Basic Mashing Tools")]), _vm._v(") until chunky\n                smooth. Add honey to taste, bring to a simmer to heat through, and finish with the\n                cream. Taste and adjust seasoning as needed. Serve very hot. ")]), _vm._v(" "), _c('div', {
    staticClass: "mediaobject",
    attrs: {
      "title": "Photo of Simply Sweet Potato Soup."
    }
  }, [_c('img', {
    attrs: {
      "alt": "Photo of Simply Sweet Potato Soup.",
      "src": "images/Simply_Sweet_Potato_Soup--Edit-958.jpg"
    }
  })]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "id": "d0e1156",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Savory Sweet Potato Breakfast\n                Flan with Sage and Sausage Crumble ")])]), _c('a', {
    attrs: {
      "id": "d0e1156",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_c('p', {
    staticClass: "yield"
  }, [_vm._v("Yields 6 to 8 servings ")]), _vm._v(" "), _c('p', [_vm._v("The morning-friendly flavors of fresh orange juice, maple syrup, and sausage make\n                this an obvious breakfast or brunch choice, but it is savory and delicious enough to\n                enjoy as a side or main dish of any meal. The silky flan texture from slow, gentle\n                cooking in a water bath is just gorgeous with floating bites of sage-kissed sausage\n                crumbles. It is as equally delicious hot from the oven as it is chilled. ")])]), _c('div', {
    staticClass: "simplelist"
  }, [_c('a', {
    attrs: {
      "id": "d0e1156",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_c('p', {
    staticClass: "nospace"
  }, [_vm._v("1 tablespoon butter, room temperature ")]), _vm._v(" "), _c('p', {
    staticClass: "nospace"
  }, [_vm._v("1 pound (450 g) mild country sausage ")]), _vm._v(" "), _c('p', {
    staticClass: "nospace"
  }, [_vm._v("1/2 teaspoon kosher or sea salt ")]), _vm._v(" "), _c('p', {
    staticClass: "nospace"
  }, [_vm._v("1/2 teaspoon ground black pepper ")]), _vm._v(" "), _c('p', {
    staticClass: "nospace"
  }, [_vm._v("1 tablespoon rubbed dry sage leaves (or ground sage) ")])]), _c('p', {
    staticClass: "nospace"
  }, [_c('a', {
    attrs: {
      "id": "d0e1156",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("1 cup (255 g) cooked, mashed sweet potatoes (")]), _c('a', {
    staticClass: "link",
    attrs: {
      "href": "#/ch04#riced",
      "id": "d0e1175",
      "title": "Basic Riced Potatoes"
    }
  }, [_vm._v("Basic Riced\n                        Potatoes")]), _vm._v(") ")]), _vm._v(" "), _c('p', {
    staticClass: "nospace"
  }, [_vm._v("1-1/2 cups (360 ml) half-and-half ")]), _vm._v(" "), _c('p', {
    staticClass: "nospace"
  }, [_vm._v("1/2 cup (120 ml) real maple syrup ")]), _vm._v(" "), _c('p', {
    staticClass: "nospace"
  }, [_vm._v("3 tablespoons sugar ")]), _vm._v(" "), _c('p', {
    staticClass: "nospace"
  }, [_vm._v("3 large eggs ")]), _vm._v(" "), _c('p', {
    staticClass: "nospace"
  }, [_vm._v("1 tablespoon fresh orange zest ")]), _vm._v(" "), _c('p', {
    staticClass: "nospace"
  }, [_vm._v("1 tablespoon fresh orange juice ")]), _vm._v(" "), _c('p', {
    staticClass: "nospace"
  }, [_vm._v("1/2 teaspoon ground cinnamon ")]), _vm._v(" "), _c('p', {
    staticClass: "nospace"
  }, [_vm._v("1/2 teaspoon ground ginger ")]), _vm._v(" "), _c('p', {
    staticClass: "nospace"
  }, [_vm._v("Pinch of ground cloves ")]), _vm._v(" "), _c('p', {
    staticClass: "nospace"
  }, [_vm._v("Salt, to taste")])]), _vm._v(" "), _c('p', [_vm._v("Preheat oven to 325° F (160° C). Butter a 2-quart (2-l) baking dish with 1 tablespoon\n                butter. Heat a large skillet over medium-high heat and crumble in the sausage,\n                stirring with a wooden spoon to break up. Season with salt, pepper, and sage.\n                Continue to cook until browned, about 5 minutes. Turn off heat, drain off any\n                visible excess fat, and set aside. ")]), _vm._v(" "), _c('p', [_vm._v("Place the remaining ingredients in the bowl of a food processor fitted with a metal\n                blade. Purée until very smooth, about 1 minute. Spread the cooked sausage in the\n                bottom of the baking dish. Pour the custard purée over the top (some of the sausage\n                will float). Place the dish in a large, deep roasting pan. Gently pour boiling water\n                around the edges of the dish to halfway up the sides. ")]), _vm._v(" "), _c('p', [_vm._v("Bake for 1 hour and 30 minutes, or until a knife inserted in the center comes out\n                clean. Remove the dish from the water, cool for 5 minutes, and serve hot with fresh\n                sage leaves for garnish, if desired. Alternatively, bring to room temperature,\n                cover, and refrigerate overnight before serving. Reheat gently over a water bath or\n                serve chilled. ")]), _vm._v(" "), _c('div', {
    staticClass: "mediaobject",
    attrs: {
      "title": "Photo of Savory Sweet Potato Breakfast Flan with Sage and Sausage Crumble ."
    }
  }, [_c('img', {
    attrs: {
      "alt": "Photo of Savory Sweet Potato Breakfast Flan with Sage and Sausage Crumble .",
      "src": "images/Savory_Sweet_Potato__Breakfast__Flan--Edit-Edit-930.jpg"
    }
  })]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "id": "spotpud",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Sweet Potato Indian Pudding ")])]), _c('a', {
    attrs: {
      "id": "spotpud",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_c('p', {
    staticClass: "yield"
  }, [_vm._v("Yields 6 to 8 servings ")]), _vm._v(" "), _c('p', [_vm._v("This rustic and gorgeous dish combines elements of a traditional New England Indian\n                pudding with ingredients widely used throughout the South—sweet potatoes and grits.\n                If you can’t find stone-ground grits, cornmeal or polenta will work fine. But skip\n                the instant variety. Longer cooking soaks up all the flavor of the pudding and melts\n                the corn into one integrated bowl of perfection. It’s best warm with a generous\n                scoop of vanilla ice cream or whipped cream on top. ")])]), _c('div', {
    staticClass: "simplelist"
  }, [_c('a', {
    attrs: {
      "id": "spotpud",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_c('p', {
    staticClass: "nospace"
  }, [_vm._v("1 tablespoon unsalted butter, room temperature ")]), _vm._v(" "), _c('p', {
    staticClass: "nospace"
  }, [_vm._v("3 cups (700 ml) half-and-half ")])]), _c('p', {
    staticClass: "nospace"
  }, [_c('a', {
    attrs: {
      "id": "spotpud",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("1 cup (255 g) cooked, mashed sweet potatoes (")]), _c('a', {
    staticClass: "link",
    attrs: {
      "href": "#/ch04#riced",
      "id": "d0e1222",
      "title": "Basic Riced Potatoes"
    }
  }, [_vm._v("Basic Riced\n                        Potatoes")]), _vm._v(") ")]), _vm._v(" "), _c('p', {
    staticClass: "nospace"
  }, [_vm._v("1/3 cup (50 g) stone-ground white or yellow grits (or cornmeal) ")]), _vm._v(" "), _c('p', {
    staticClass: "nospace"
  }, [_vm._v("1/4 cup (60 ml) molasses ")]), _vm._v(" "), _c('p', {
    staticClass: "nospace"
  }, [_vm._v("2 large eggs ")]), _vm._v(" "), _c('p', {
    staticClass: "nospace"
  }, [_vm._v("1/2 cup (110 g) firmly packed dark brown sugar ")]), _vm._v(" "), _c('p', {
    staticClass: "nospace"
  }, [_vm._v("1 teaspoon kosher or sea salt ")]), _vm._v(" "), _c('p', {
    staticClass: "nospace"
  }, [_vm._v("2 teaspoons real vanilla extract ")]), _vm._v(" "), _c('p', {
    staticClass: "nospace"
  }, [_vm._v("1 teaspoon ground ginger ")]), _vm._v(" "), _c('p', {
    staticClass: "nospace"
  }, [_vm._v("1 teaspoon ground cinnamon ")]), _vm._v(" "), _c('p', {
    staticClass: "nospace"
  }, [_vm._v("2 tablespoons cold unsalted butter, cut into 1/4-inch (6-mm)\n                    cubes ")]), _vm._v(" "), _c('p', {
    staticClass: "nospace"
  }, [_vm._v("Vanilla ice cream or whipped cream")])]), _vm._v(" "), _c('p', [_vm._v("Preheat oven to 350° F (175° C). Butter a 1.5- to 2-quart (1.5- to 2-l) deep-sided\n                baking dish with 1 tablespoon butter. ")]), _vm._v(" "), _c('p', [_vm._v("Bring the half-and-half to a simmer over medium-high heat in a medium pot. Do not\n                boil. When simmering, whisk in the sweet potatoes, grits, and molasses. Whisk\n                constantly over medium-high heat until thickened to a thin pudding stage, about 5\n                minutes. Turn off heat and set aside. ")]), _vm._v(" "), _c('p', [_vm._v("In a large bowl, whisk together the eggs, brown sugar, salt, vanilla, ginger, and\n                cinnamon until frothy. Whisk in 1 cup of the warm pudding mixture. Pour in the\n                remaining pudding mixture and whisk to combine. Pour the pudding into the baking\n                dish. Bake in oven on the center rack for 40 minutes. ")]), _vm._v(" "), _c('p', [_vm._v("Add the cold butter cubes, sprinkling evenly over the top. Reduce the heat to 325° F\n                (160° C). Cook for 45–50 minutes, until a knife inserted in the center comes out\n                clean. The pudding will quiver slightly to the touch. Remove from oven. Let rest for\n                10–15 minutes before serving. Serve warm with vanilla ice cream or whipped cream. ")]), _vm._v(" "), _c('div', {
    staticClass: "mediaobject",
    attrs: {
      "title": "Photo of Sweet Potato Indian Pudding."
    }
  }, [_c('img', {
    attrs: {
      "alt": "Photo of Sweet Potato Indian Pudding.",
      "src": "images/Sweet_Potato_Indian_Pudding_--Edit-959.jpg"
    }
  })]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "id": "d0e1258",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Sweet Potato–Macadamia Nut Ice\n                Cream ")])]), _c('a', {
    attrs: {
      "id": "d0e1258",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_c('p', {
    staticClass: "yield"
  }, [_vm._v("Yields 6 servings ")]), _vm._v(" "), _c('p', [_vm._v("The sweet potatoes give this ice cream a warm sunset hue and silky texture, while the\n                macadamia nuts provide a crunchy finish that will not be soon forgotten. ")])]), _c('div', {
    staticClass: "simplelist"
  }, [_c('a', {
    attrs: {
      "id": "d0e1258",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_c('p', {
    staticClass: "nospace"
  }, [_vm._v("1-1/4 cups (300 ml) whole milk ")]), _vm._v(" "), _c('p', {
    staticClass: "nospace"
  }, [_vm._v("2 cups (475 ml) whipping cream ")])]), _c('p', {
    staticClass: "nospace"
  }, [_c('a', {
    attrs: {
      "id": "d0e1258",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("1 cup (255 g) cooked, mashed sweet potatoes (")]), _c('a', {
    staticClass: "link",
    attrs: {
      "href": "#/ch04#riced",
      "id": "d0e1271",
      "title": "Basic Riced Potatoes"
    }
  }, [_vm._v("Basic Riced\n                        Potatoes")]), _vm._v(") ")]), _vm._v(" "), _c('p', {
    staticClass: "nospace"
  }, [_vm._v("3/4 cup (150 g) sugar ")]), _vm._v(" "), _c('p', {
    staticClass: "nospace"
  }, [_vm._v("6 egg yolks ")]), _vm._v(" "), _c('p', {
    staticClass: "nospace"
  }, [_vm._v("1 teaspoon real vanilla extract ")]), _vm._v(" "), _c('p', {
    staticClass: "nospace"
  }, [_vm._v("1 teaspoon pumpkin pie spice ")]), _vm._v(" "), _c('p', {
    staticClass: "nospace"
  }, [_vm._v("1 teaspoon cinnamon ")]), _vm._v(" "), _c('p', {
    staticClass: "nospace"
  }, [_vm._v("Pinch cloves ")]), _vm._v(" "), _c('p', {
    staticClass: "nospace"
  }, [_vm._v("Pinch of kosher or sea salt ")]), _vm._v(" "), _c('p', {
    staticClass: "nospace"
  }, [_vm._v("1/2 cup (65 g) coarsely chopped salted macadamia nuts")])]), _vm._v(" "), _c('p', [_vm._v("Bring the milk and cream to an aggressive simmer in a saucepan over medium-high heat.\n                In a large bowl, whisk together the sweet potatoes, sugar, and egg yolks until\n                frothy. Whisk in the vanilla, pumpkin pie spice, cinnamon, cloves, and salt until\n                smooth. Once the milk and cream have come to a simmer, slowly whisk into the egg\n                mixture, stirring constantly. Return the entire mixture to the saucepan and cook\n                over medium heat, stirring constantly with a wooden spoon. The custard is done once\n                it starts to coat the back of the spoon and bubbles on top have disappeared, about 5\n                minutes. ")]), _vm._v(" "), _c('p', [_vm._v("Remove from the heat and strain through a fine-mesh strainer into a bowl set onto a\n                bed of ice; let cool completely, stirring occasionally. Freeze in an ice cream maker\n                according to manufacturer’s directions. Add the macadamia nuts once the ice cream is\n                halfway set and still fairly soft, about 12 minutes into the freezing process. ")]), _vm._v(" "), _c('p', [_vm._v("Serve plain, or garnish with additional chopped macadamia nuts and whipped cream for\n                garnish.")]), _vm._v(" "), _c('div', {
    staticClass: "mediaobject",
    attrs: {
      "title": "Photo of Sweet Potato–Macadamia Nut Ice Cream ."
    }
  }, [_c('img', {
    attrs: {
      "alt": "Photo of Sweet Potato–Macadamia Nut Ice Cream .",
      "src": "images/Sweet_Potato_Macadamia_Nut_Ice_Cream--Edit-Edit-929.jpg"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-945d7ba2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ch04.vue
// module id = 75
// module chunks = 0